import React, { useRef, useMemo, useState, useEffect, useLayoutEffect, useCallback, useImperativeHandle, forwardRef } from "react";
import ReportPdf from "../ReportPDF/ReportPdf";
import CleanHtml from "./CleanHtml";
import Medicalindex from "./Medicalindexreport"
import MedChronReport from "./Medchronreport"
import SearchResultTable from "./Searchresult";
import SubmittalsReport from "./Submittalsreport";
import MissingorDuplicatereport from "./MissingorDuplicate";
import AisummaryagentInprogress from "./SummaryInprogress";
import MindmapApp from "./Mindmap/Mindmap";

//import html2pdf from "html2pdf.js";
import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
import { Document, Packer, Paragraph, TextRun, Header, ImageRun, Table, TableRow, TableCell } from "docx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaFilePdf, FaFileWord } from "react-icons/fa";
import DOMPurify from "dompurify";
import axios from "axios";
import { API_BASE_URL } from "../../global";
import loadImg from "../Assets/images/animated-logo.gif";
import { TypeAnimation } from "react-type-animation";
import JSZip from "jszip";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from "../Assets/images/fav-icon.png";
import { Pagination, Table as Table1, Button as Button1, Dropdown } from 'react-bootstrap';
import { Modal } from "react-bootstrap";


import {
  faUpload,
  faBell,
  faScissors,
  faFileLines,
  faRobot,
  faFile,
  faListUl
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import {
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Badge,
  Card,
  CardBody,
  Spinner
} from 'reactstrap';
import { Tooltip } from 'react-tooltip';
import TypingEffect from './TypingEffect';
import docIcon from '../Assets/images/docIcon.png';
import pdfIcon from '../Assets/images/pdfIcon.png';
import docSvg from '../Assets/images/doc.svg';
import pdfSvg from '../Assets/images/pdf.svg';
import docImg from '../Assets/images/docImg.png';
import pdfImg from '../Assets/images/pdfImg.png';
import agent1 from '../Assets/images/agent-1.png';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';


//chat conroled reender use memo react start
const ChatMessage = React.memo(function ChatMessage({ msg, index, onComplete }) {
  const formatTimestamp = (utcString) => {
    const inputTime = moment.utc(utcString).local(); // Convert UTC → Local
    const now = moment(); // Local time

    if (inputTime.isSame(now, 'day')) {
      return `Today ${inputTime.format('hh:mm A')}`;
    } else if (inputTime.isSame(moment().subtract(1, 'day'), 'day')) {
      return `Yesterday ${inputTime.format('hh:mm A')}`;
    } else {
      return inputTime.format('YYYY-MM-DD hh:mm A');
    }
  };

  const getFirstLetter = (data) => {
    return data && data.trim() ? data.trim().charAt(0).toUpperCase() : "";
  };
  return (
    <li className={msg.sender}>
      <div className="d-flex justify-content-start gap-1">
        <div
          className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          title="Profile"
        >
          {getFirstLetter(msg.sender === "ai" ? 'AttestaAI' : localStorage.getItem("username"))}
        </div>
        <div>
          {msg.sender === "ai" && msg.animate ? (
            <>
              <TypingEffect text={msg.text} onComplete={() => onComplete(index)} />
              <div style={{ fontSize: "9px", textAlign: "start" }}>
                {formatTimestamp(msg.created_on)}
              </div>
            </>
          ) : (
            <>
              <span
                dangerouslySetInnerHTML={{ __html: msg.text }}
                style={{ display: "inline-block" }}
              />
              <div style={{ fontSize: "9px", textAlign: "start" }}>
                {formatTimestamp(msg.created_on)}
              </div>
            </>
          )}
        </div>
      </div>
    </li>
  );
});
//chat conroled reender use memo react end


//serach modal start 
const SmartSearchModal = forwardRef(({ isOpen, closeModal, searchenable, handlekeywordstring, searchdisable }, ref) => {
  const fieldOptions = [
    { value: '', label: '--Select Field--' },
    { value: 'content', label: 'Case Document' },
    // { value: 'date', label: 'Date' },
    // { value: 'provider', label: 'Provider' },
    // { value: 'title', label: 'Title' },
    // { value: 'page_range', label: 'Page Range' },
    { value: 'notes', label: 'Notes' },
    { value: 'tags', label: 'Tags' }
  ];

  const fieldToConditionsMap = {
    content: [{ value: 'like', label: 'Like' }],
    date: [{ value: 'like', label: 'Like' }, { value: 'between', label: 'Between' }],
    provider: [
      { value: 'like', label: 'Like' },
      { value: 'equal', label: 'Equal' },
      { value: 'in', label: 'In' },
      { value: 'not_in', label: 'Not In' },
      { value: 'not_equal', label: 'Not Equal' }
    ],
    title: [
      { value: 'like', label: 'Like' },
      { value: 'equal', label: 'Equal' },
      { value: 'in', label: 'In' },
      { value: 'not_in', label: 'Not In' },
      { value: 'not_equal', label: 'Not Equal' }
    ],
    page_range: [
      { value: 'like', label: 'Like' },
      { value: 'equal', label: 'Equal' },
      { value: 'in', label: 'In' },
      { value: 'not_in', label: 'Not In' },
      { value: 'not_equal', label: 'Not Equal' }
    ],
    notes: [{ value: 'like', label: 'Like' }],
    tags: [{ value: 'contain', label: 'Contains' }]
  };

  const [filters, setFilters] = useState([{ field: '', condition: '', keyword: '', keyword2: '', operation: '' }]);
  const [showSmartSearch, setShowSmartSearch] = useState(false);
  const [showSearchHistory, setShowSearchHistory] = useState(false);

  const toggleSmartSearch = () => setShowSmartSearch(!showSmartSearch);
  const toggleSearchHistory = () => setShowSearchHistory(!showSearchHistory);
  const [saveSearch, setSaveSearch] = useState(false);
  const [searchTitle, setSearchTitle] = useState("");
  const [savedSearches, setSavedSearches] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [showAllSavedSearches, setShowAllSavedSearches] = useState(false);
  const toggleSavedSearchView = () => setShowAllSavedSearches(!showAllSavedSearches);


  const [tags, setTags] = useState([]);
  const [createdTags, setCreatedTags] = useState([]);
  // Fetch tags list
  const handleTagslist = async () => {
    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.post(`${API_BASE_URL}tag`, {
        case_id: caseID,
        mode: "listAllTag",
        get_type: "all_tags"
      });

      if (response.data.status === 1) {
        const responsedata = response.data?.message?.all_tags || [];
        if (Array.isArray(responsedata)) {
          setCreatedTags(responsedata);
        } else {
          setCreatedTags([]);
        }
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  useImperativeHandle(ref, () => ({
    resetFilters: () => {
      setFilters([{ field: '', condition: '', keyword: '', keyword2: '', operation: '' }]);
      setSaveSearch(false);
      setSearchTitle('');
      setKeyword('');
    },
  }));


  const handleFieldChange = (index, value) => {
    const updated = [...filters];
    updated[index].field = value;
    updated[index].condition = '';
    updated[index].keyword = '';
    updated[index].keyword2 = '';
    if (value === 'tags') {
      handleTagslist();
    }
    setFilters(updated);
  };

  const handleChange = (index, key, value) => {
    const updated = [...filters];
    updated[index][key] = value;
    setFilters(updated);
  };

  const addFilterRow = () => {
    setFilters([...filters, { field: '', condition: '', keyword: '', operation: '' }]);
  };

  const removeFilterRow = (index) => {
    const updated = filters.filter((_, i) => i !== index);
    setFilters(updated);
  };
  const generateQuery = () => {
    let query = '';

    filters.forEach((item, index) => {
      let part = '';

      switch (item.condition) {
        case 'like':
          // part = `${item.field} LIKE '%%${item.keyword}%%'`;
          if (item.field === 'content') {
            part = `tfc.content LIKE '%%${item.keyword}%%'`;
          } else if (item.field === 'notes') {
            part = `tcn.note_content LIKE '%%${item.keyword}%%'`;
          }
          break;
        case 'equal':
          part = `${item.field} = '${item.keyword}'`;
          break;
        case 'contain':
          part = `tctm.tag_name IN ('${item.keyword}')`;
          break;
        case 'not_equal':
          part = `${item.field} != '${item.keyword}'`;
          break;
        case 'in':
          part = `${item.field} IN ('${item.keyword.join("', '")}')`;
          break;
        case 'not_in':
          part = `${item.field} NOT IN ('${item.keyword.join("', '")}')`;
          break;
        case 'between':
          part = `(${item.field} >= '${item.keyword}' AND ${item.field} <= '${item.keyword2}')`;
          break;
        default:
          break;
      }
      // For the first item, just add the part without any operator

      if (part) {
        query += part;
        // Append operation if not last item
        if (index < filters.length - 1 && item.operation) {
          query += ` ${item.operation.toUpperCase()} `;
        }
      }

    });

    return query;
  };
  const generatevalue = () => {
    let query = '';

    filters.forEach((item, index) => {
      let part = '';

      switch (item.condition) {
        case 'like':
          // part = `${item.field} LIKE '%%${item.keyword}%%'`;
          if (item.field === 'content') {
            part = `Document Content LIKE ${item.keyword}`;
          } else if (item.field === 'notes') {
            part = `Notes LIKE ${item.keyword}`;
          }
          break;
        case 'equal':
          part = `${item.field} = '${item.keyword}'`;
          break;
        case 'contain':
          part = `Tags CONTAINS ${item.keyword}`;
          //   if (item.field === 'tags') {
          //   // Find the tag name based on tagId in keyword
          //   const tag = createdTags.find(tag => tag.tagId === parseInt(item.keyword));
          //   if (tag) {
          //     part = `Tags CONTAINS ${tag.tagContent}`;
          //   } else {
          //     part = ''; // If tag not found, skip this filter
          //   }
          // }

          break;
        case 'not_equal':
          part = `${item.field} != '${item.keyword}'`;
          break;
        case 'in':
          part = `${item.field} IN ('${item.keyword.join("', '")}')`;
          break;
        case 'not_in':
          part = `${item.field} NOT IN ('${item.keyword.join("', '")}')`;
          break;
        case 'between':
          part = `(${item.field} >= '${item.keyword}' AND ${item.field} <= '${item.keyword2}')`;
          break;
        default:
          break;
      }
      // For the first item, just add the part without any operator
      // query += ` ${part} ${item.operation?.toUpperCase()}`;
      if (part) {
        query += part;
        // Append operation if not last item
        if (index < filters.length - 1 && item.operation) {
          query += ` ${item.operation.toUpperCase()} `;
        }
      }

    });

    return query;
  };

  const handleSearch = async (type, item = null) => {

    let query = "";
    let extraData = {};
    let keywords = [];
    let search_types = [];
    let filterdata = [];

    if (type === 2) {

      const isValid = filters.every((filter, index) => {

        if (!filter.field || !filter.condition || !filter.keyword) {
          return false;
        }
        if (filter.condition === 'between' && (!filter.keyword2 || !filter.keyword)) {
          return false;
        }
        // if (index > 0 && !filter.operation) {
        //   return false;
        // }
        if (index < filters.length - 1 && !filter.operation) {
          return false;
        }
        return true;
      });

      // If the validation fails, show an alert and exit
      if (!isValid) {
        toast.warning("Please complete all fields correctly before searching.");
        return;
      }

      filterdata = filters;

      filters.forEach(filter => {
        search_types.push(filter.field)
        if (filter.keyword) {
          keywords.push(filter.keyword);
          if (filter.keyword2) {
            keywords.push(filter.keyword2);
          }
        }
      });
      if (saveSearch) {
        if (!searchTitle) {
          toast.warning("Please provide a title for the saved search.");
          return;
        }
        search_types.push("save_search")
        extraData = { savesearch: saveSearch, search_name: searchTitle };
      } else {
        extraData = {};
      }

      const searchvaluestring = generatevalue()
      setKeyword(searchvaluestring || "")
      handlekeywordstring(searchvaluestring)
      query = generateQuery();

    } else if (type === 3) {
      query = item.searchId;
      search_types.push("quick_search")
      const searchname = item.searchName ? `${item.searchName}(${item.searchCreated})` : "";
      handlekeywordstring(searchname);
      setKeyword(searchname || "")
      filterdata = item.searchId;
    } else {
      query = `tfc.content LIKE '%%${keyword}%%'`;
      keywords = Array.isArray(keyword) ? keyword : [keyword];
      handlekeywordstring(keyword);
      setKeyword(keyword || "");
      filterdata = keyword;

    }


    const CaseId = localStorage.getItem('caseID') || "";
    try {
      const response = await axios.post(`${API_BASE_URL}search`, {
        search_value: query,
        case_id: CaseId,
        search_keywords: keywords,
        search_types: search_types,
        filterdata: filterdata,
        ...extraData
      });

      if (response.status === 200) {
        const searchresult = response.data.message

        if (Array.isArray(searchresult)) {
          const modifiedData = { ...response.data, type: 1 };
          searchenable(modifiedData);
          closeModal();
        } else {
          toast.warning(response.data.message);
          setKeyword("");
          searchdisable();

        }

      }

    } catch (error) {
      console.error('Error during API request:', error);
    }

  };





  const handlekeywordChange = (field, value) => {
    if (field === 'keyword') {
      setKeyword(value);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch(1);
    }
  };

  const fetchsavedsearchlist = async () => {

    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.get(`${API_BASE_URL}search?cId=${caseID}`);
      const savedsearchList = response.data?.message || [];

      if (Array.isArray(savedsearchList)) {
        setSavedSearches(savedsearchList);
      } else {
        setSavedSearches([]);

      }
    } catch (error) {
      console.error("Error fetching saved search data:", error);
    } finally {

    }
  };



  useEffect(() => {
    if (isOpen) {
      fetchsavedsearchlist();
    }
  }, [isOpen]);
  if (!isOpen) return null;



  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {/* Modal Header */}
        <div className="d-flex justify-content-between align-items-center border-bottom py-2 px-3">
          <input
            type="text"
            className="form-control"
            placeholder="Keyword"
            value={keyword}
            onChange={(e) => handlekeywordChange('keyword', e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button onClick={closeModal} className="btn border-0 fs-5">
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Accordion-like Smart Search Section */}
        <div className="accordion-section border-bottom">
          <div
            className="d-flex justify-content-between align-items-center p-3 cursor-pointer"
            onClick={toggleSmartSearch}
            style={{ fontWeight: "bold" }}
          >
            <span>Click here for smart search</span>
            <i className={`fas fa-chevron-${showSmartSearch ? 'up' : 'down'}`}></i>
          </div>

          {showSmartSearch && (
            <div className="px-3 pb-3">
              {filters.map((filter, index) => {
                const conditions = fieldToConditionsMap[filter.field] || [];
                const isDateField = filter.field === 'date';
                const isBetween = filter.condition === 'between';
                const isLastFilter = index === filters.length - 1;
                return (
                  <div className="row g-2 align-items-center mb-2" key={index}>
                    <div className="col-3">
                      <select
                        className="form-select"
                        value={filter.field}
                        onChange={(e) => handleFieldChange(index, e.target.value)}
                      >
                        {fieldOptions.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-2">
                      <select
                        className="form-select"
                        value={filter.condition}
                        onChange={(e) => handleChange(index, 'condition', e.target.value)}
                        disabled={!filter.field}
                      >
                        <option value="">--Condition--</option>
                        {conditions.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-3">
                      {isDateField && isBetween ? (
                        <div className="d-flex gap-2">
                          <DatePicker
                            selected={filter.keyword ? new Date(filter.keyword) : null}
                            onChange={(date) =>
                              handleChange(index, 'keyword', format(date, 'MM/dd/yyyy'))
                            }
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Start Date"
                          />
                          <DatePicker
                            selected={filter.keyword2 ? new Date(filter.keyword2) : null}
                            onChange={(date) =>
                              handleChange(index, 'keyword2', format(date, 'MM/dd/yyyy'))
                            }
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="End Date"
                          />
                        </div>
                      ) : isDateField ? (
                        <DatePicker
                          selected={filter.keyword ? new Date(filter.keyword) : null}
                          onChange={(date) =>
                            handleChange(index, 'keyword', format(date, 'MM/dd/yyyy'))
                          }
                          className="form-control"
                          dateFormat="MM/dd/yyyy"
                          placeholderText="Select Date"
                        />
                      ) : filter.field === 'tags' ? (
                        <select
                          className="form-select"
                          value={filter.keyword}
                          onChange={(e) => handleChange(index, 'keyword', e.target.value)}
                        >
                          <option value="">--Select Tag--</option>
                          {createdTags.map((tag, i) => (
                            <option key={tag.tagId} value={tag.tagContent}>
                              {tag.tagContent}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Keyword"
                          value={filter.keyword}
                          onChange={(e) => handleChange(index, 'keyword', e.target.value)}
                        />
                      )}
                    </div>

                    <div className="col-2">
                      {isLastFilter && (
                        <Tooltip id="operator-status" className="tooltip-custom" place="top" strategy="fixed" offset={10}>
                          Add Filter To Enable The Operator
                        </Tooltip>
                      )}

                      <select
                        className="form-select"
                        value={filter.operation}
                        onChange={(e) => handleChange(index, 'operation', e.target.value)}
                        disabled={isLastFilter}
                        data-tooltip-id={isLastFilter ? "operator-status" : undefined}
                        data-tooltip-content={isLastFilter ? "Add Filter To Enable The Operator" : undefined}
                      >
                        <option value="">--Operation--</option>
                        <option value="and">AND</option>
                        <option value="or">OR</option>
                      </select>
                    </div>

                    <div className="col-1 d-flex justify-content-center">
                      {index === 0 ? (
                        <button onClick={addFilterRow} className="btn attesta-outline-btn btn-sm">
                          <i className="fas fa-plus"></i>
                        </button>
                      ) : (
                        <button onClick={() => removeFilterRow(index)} className="btn btn-outline-danger btn-sm">
                          <i className="fas fa-trash"></i>
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}

              <label className="mt-2">Do you want to save this search?</label>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex mb-0">

                  {/*  */}
                  <input
                    type="checkbox"
                    className="form-check-input me-2 mt-2"
                    checked={saveSearch}
                    onChange={(e) => setSaveSearch(e.target.checked)}
                  />

                  <input
                    type="text"
                    className="form-control mt-1"
                    placeholder="Set search title"
                    value={searchTitle}
                    onChange={(e) => setSearchTitle(e.target.value)}
                    disabled={!saveSearch}
                    style={{ minWidth: '320px' }}
                  />

                </div>
                <button className="btn attesta-blue-btn ms-auto mt-4" onClick={() => handleSearch(2)}>
                  Search <i className="fas fa-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          )}
        </div>
        {/* Search History Accordion */}
        <div>
          <div
            className="d-flex justify-content-between align-items-center p-3 cursor-pointer"
            onClick={toggleSearchHistory}
          >
            <strong>Quick search and search history</strong>
            <i className={`fas fa-chevron-${showSearchHistory ? "up" : "down"}`}></i>
          </div>

          {showSearchHistory && (
            <div className="px-3 pb-3">
              {savedSearches.length === 0 ? (
                <div className="text-muted">No saved searches yet.</div>
              ) : (
                // <ul className="list-group">
                //   {savedSearches.map((item, i) => (
                //     <li className="list-group-item d-flex justify-content-between" key={i}>
                //       <span>{item.searchName}</span>
                //       <button className="btn btn-link btn-sm" onClick={() => handleSearch(3, item)}>Load</button>
                //     </li>
                //   ))}
                // </ul>
                <>
                  <ul
                    className="list-group"
                    style={
                      showAllSavedSearches
                        ? { maxHeight: '200px', overflowY: 'auto' }
                        : {}
                    }
                  >
                    {(showAllSavedSearches ? savedSearches : savedSearches.slice(0, 3)).map((item, i) => (
                      // <li className="list-group-item d-flex justify-content-between" key={i}>
                      //   <span>{item.searchName}({item.searchCreated})</span>
                      //   <button className="btn btn-link btn-sm" onClick={() => handleSearch(3, item)}>Load</button>
                      // </li>
                      <li
                        className="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
                        key={i}
                        style={{ fontSize: "0.9rem", border: "none", borderBottom: "1px solid #eee" }}
                      >
                        <span className="text-dark" onClick={() => handleSearch(3, item)}>
                          <i class="fa-solid fa-arrows-rotate me-1"></i>
                          {item.searchName} ({item.searchCreated})
                        </span>

                      </li>


                    ))}
                  </ul>
                  {savedSearches.length > 3 && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={toggleSavedSearchView}
                      >
                        {showAllSavedSearches ? 'Show Less' : 'View More'}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});


const TagsModal = ({ showTags, closeTagsModal, alltags, searchenable, searchdisable }) => {
  if (!showTags) return null;
  const tags = alltags.all_pages_active_tags || [];
  const alltagscount = alltags.all_pages_active_tags_count || 0;

  const tagsPerPage = 5; // Number of tags per page
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumbers, setPageNumbers] = useState([]);
  const [totalTags, settotalTags] = useState(tags.length || 0);

  const totalPages = Math.ceil(totalTags / tagsPerPage);

  // Get the tags to be displayed on the current page
  const displayedTags = tags.slice(
    (currentPage - 1) * tagsPerPage,
    currentPage * tagsPerPage
  );

  // Generate page numbers for pagination
  const generatePageNumbers = () => {
    const range = [];


    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      const leftEllipsis = currentPage > 3;
      const rightEllipsis = currentPage < totalPages - 2;

      if (leftEllipsis) range.push(1);
      if (leftEllipsis && currentPage > 2) range.push("...");

      const start = Math.max(1, currentPage - 2);
      const end = Math.min(totalPages, currentPage + 2);

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      if (rightEllipsis && currentPage < totalPages - 2) range.push("...");
      if (rightEllipsis) range.push(totalPages);
    }

    setPageNumbers(range);
  };

  // Call to generate page numbers whenever the page changes
  useEffect(() => {
    generatePageNumbers();
  }, [currentPage, tags]);

  // Handle pagination click
  const paginate = (pageNumber) => {
    if (pageNumber === "...") return;
    setCurrentPage(pageNumber);
  };

  // Handle fast backward (skip to first page)
  const fastBackward = () => {
    setCurrentPage(1);
  };

  // Handle fast forward (skip to last page)
  const fastForward = () => {
    const lastPage = Math.ceil(tags.length / tagsPerPage);
    setCurrentPage(lastPage);
  };


  const handletagSearch = async (tagid = null) => {

    const CaseId = localStorage.getItem('caseID') || "";
    try {
      const response = await axios.post(`${API_BASE_URL}search`, {
        case_id: CaseId,
        "search_value": tagid,
        "search_keywords": [],
        "search_types": [
          "page_tag"
        ]

      });

      if (response.status === 200) {
        const searchresult = response.data.message

        if (Array.isArray(searchresult)) {
          const modifiedData = { ...response.data, type: 3 };
          searchenable(modifiedData);
          closeTagsModal();
        } else {
          toast.warning(response.data.message);
          searchdisable();
        }

      }

    } catch (error) {
      console.error('Error during API request:', error);
    }

  };

  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{
        width: "700px",
        maxHeight: "80vh",
        overflow: "hidden",
      }}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center border-bottom py-2 px-3">
          <h5 className="m-0">All Tags ({alltagscount})</h5>
          <button onClick={closeTagsModal} className="btn border-0 fs-5">
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Table */}
        <div
          style={{
            // minHeight: "200px",
            maxHeight: "calc(-310px + 100vh)",
            overflowY: "auto",
          }}
        >
          {tags.length === 0 ? (
            <p className="text-muted">No tags found.</p>
          ) : (
            <Table1 hover>
              <thead className="custom-header-border">
                <tr>
                  <th className="center-text">S. No.</th>
                  <th className="center-text">Tag</th>
                  <th className="center-text">Associated Pages</th>
                  <th className="center-text">Actions</th>
                </tr>
              </thead>
              <tbody>
                {displayedTags.map((tag, index) => (
                  <tr key={tag.tagId} className="custom-row-border">
                    <td className="center-text">
                      {(currentPage - 1) * tagsPerPage + (index + 1)}
                    </td>
                    <td className="center-text">#{tag.tagName}</td>
                    <td className="center-text">{tag.tagPagesAssociate.join(", ")}</td>
                    <td className="center-text">
                      <Button1 variant="outline-primary" size="sm" onClick={() => handletagSearch(tag.tagId)}>
                        <i className="fas fa-eye"></i>
                      </Button1>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table1>
          )}
        </div>

        {/* Pagination */}
        <Pagination className="custom-pagination justify-content-end mt-1">
          <Pagination.First onClick={fastBackward} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
          {pageNumbers.map((number, idx) => (
            <Pagination.Item
              key={idx}
              active={number === currentPage}
              onClick={() => paginate(number)}
            >
              {number}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers[pageNumbers.length - 1]} />
          <Pagination.Last onClick={fastForward} disabled={currentPage === pageNumbers[pageNumbers.length - 1]} />
        </Pagination>
      </div>
    </div>
  );
};



const NotesModal = ({ showNotes, closeNotesModal, allnotes, searchenable, searchdisable }) => {
  if (!showNotes) return null;
  const notes = allnotes.all_active_notes_list || [];
  const notesPerPage = 5; // Number of notes per page
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumbers, setPageNumbers] = useState([]);

  const totalNotes = notes.length;
  const totalPages = Math.ceil(totalNotes / notesPerPage);

  // Get the notes to be displayed on the current page
  const displayedNotes = notes.slice(
    (currentPage - 1) * notesPerPage,
    currentPage * notesPerPage
  );

  // Generate page numbers for pagination with ellipses
  const generatePageNumbers = () => {
    const range = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      const leftEllipsis = currentPage > 3;
      const rightEllipsis = currentPage < totalPages - 2;

      if (leftEllipsis) range.push(1);
      if (leftEllipsis && currentPage > 2) range.push("...");

      const start = Math.max(1, currentPage - 2);
      const end = Math.min(totalPages, currentPage + 2);

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      if (rightEllipsis && currentPage < totalPages - 2) range.push("...");
      if (rightEllipsis) range.push(totalPages);
    }

    setPageNumbers(range);
  };

  // Call to generate page numbers whenever the page changes
  useEffect(() => {
    generatePageNumbers();
  }, [currentPage, totalPages]);

  // Handle pagination click
  const paginate = (pageNumber) => {
    if (pageNumber === "...") return;
    setCurrentPage(pageNumber);
  };

  // Handle fast backward (skip to first page)
  const fastBackward = () => {
    setCurrentPage(1);
  };

  // Handle fast forward (skip to last page)
  const fastForward = () => {
    setCurrentPage(totalPages);
  };


  const handlenoteSearch = async (item = null) => {

    const CaseId = localStorage.getItem('caseID') || "";
    try {
      const response = await axios.post(`${API_BASE_URL}search`, {
        case_id: CaseId,
        "search_value": item,
        "search_keywords": [],
        "search_types": [
          "page_note"
        ]

      });

      if (response.status === 200) {
        const searchresult = response.data.message

        if (Array.isArray(searchresult)) {
          const modifiedData = { ...response.data, type: 2 };
          searchenable(modifiedData);
          closeNotesModal();
        } else {
          toast.warning(response.data.message);
          searchdisable();
        }

      }

    } catch (error) {
      console.error('Error during API request:', error);
    }

  };


  const handleButtonClick = (e, noteId) => {
    e.stopPropagation(); // Prevent the click event from bubbling up to the tr
    handlenoteSearch(noteId);
  };


  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center border-bottom py-2 px-3">
          <h5 className="m-0">All Notes ({totalNotes})</h5>
          <button onClick={closeNotesModal} className="btn border-0 fs-5">
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Table */}
        <div
          style={{
            // minHeight: "200px",
            maxHeight: "calc(-310px + 100vh)",
            overflowY: "auto"
          }}
        >
          <Table1 hover>
            <thead className="custom-header-border">
              <tr >
                <th className="center-text">S. No.</th>
                <th className="center-text" >Notes</th>
                <th className="center-text" >Page No</th>
                <th className="center-text" >Created Date</th>
                <th className="center-text" >Actions</th>
              </tr>
            </thead>
            <tbody>
              {displayedNotes.length > 0 ? (
                displayedNotes.map((note, index) => (
                  <tr key={note.noteId} className="custom-row-border" onClick={() => handlenoteSearch(note.noteId)}>
                    <td className="center-text">
                      {(currentPage - 1) * notesPerPage + (index + 1)}
                    </td>
                    <td
                      className="wrap-text"
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note?.noteContent || "") }}
                    ></td>
                    <td className="center-text">{note.notePageNo}</td>
                    <td className="center-text">{note.noteCreated}</td>

                    <td className="center-text">

                      <Tooltip id={`view-tooltip-${index}`} className="tooltip-custom" place="top" />
                      {/* Tooltip for View in Document Button */}
                      <div
                        data-tooltip-id={`view-tooltip-${index}`}
                        data-tooltip-content="View in Document"
                      >
                        <Button1 variant="outline-primary" size="sm"
                          // onClick={() => handlenoteSearch(note.noteId)}
                          onClick={(e) => handleButtonClick(e, note.noteId)}
                        >
                          <i className="fas fa-eye"></i>
                        </Button1>
                      </div>

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-3">
                    No notes available
                  </td>
                </tr>
              )}
            </tbody>
          </Table1>
        </div>

        {/* Pagination */}
        {/* <Pagination className="custom-pagination justify-content-end mt-1">
          <Pagination.First onClick={fastBackward} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
          {pageNumbers.map((page, idx) => {
            if (page === "...") {
              return (
                <Pagination.Ellipsis key={idx} disabled>
                  <span>...</span>
                </Pagination.Ellipsis>
              );
            }

            return (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => paginate(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}
          <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
          <Pagination.Last onClick={fastForward} disabled={currentPage === totalPages} />
        </Pagination> */}
        <Pagination className="custom-pagination justify-content-end mt-1">
          <Pagination.First onClick={fastBackward} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
          {pageNumbers.map((number, idx) => (
            <Pagination.Item
              key={idx}
              active={number === currentPage}
              onClick={() => paginate(number)}
            >
              {number}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers[pageNumbers.length - 1]} />
          <Pagination.Last onClick={fastForward} disabled={currentPage === pageNumbers[pageNumbers.length - 1]} />
        </Pagination>
      </div>
    </div>
  );
};

const TimelinereportModal = ({ showTimelineModal, closeTimelinedataModal, alltimelinedata }) => {
  if (!showTimelineModal) return null;

  const Timelinedata = alltimelinedata || [];
  console.log(Timelinedata)
  const allTimelinedatacount = alltimelinedata.length || 0;

  const TimelinedataPerPage = 5; // Number of Timelinedata per page
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumbers, setPageNumbers] = useState([]);
  const [totalTimelinedata, settotalTimelinedata] = useState(Timelinedata.length || 0);

  const totalPages = Math.ceil(totalTimelinedata / TimelinedataPerPage);

  // Get the Timelinedata to be displayed on the current page
  const displayedTimelinedata = Timelinedata.slice(
    (currentPage - 1) * TimelinedataPerPage,
    currentPage * TimelinedataPerPage
  );

  // Generate page numbers for pagination
  const generatePageNumbers = () => {
    const range = [];


    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      const leftEllipsis = currentPage > 3;
      const rightEllipsis = currentPage < totalPages - 2;

      if (leftEllipsis) range.push(1);
      if (leftEllipsis && currentPage > 2) range.push("...");

      const start = Math.max(1, currentPage - 2);
      const end = Math.min(totalPages, currentPage + 2);

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      if (rightEllipsis && currentPage < totalPages - 2) range.push("...");
      if (rightEllipsis) range.push(totalPages);
    }

    setPageNumbers(range);
  };

  // Call to generate page numbers whenever the page changes
  useEffect(() => {
    generatePageNumbers();
  }, [currentPage, Timelinedata]);

  // Handle pagination click
  const paginate = (pageNumber) => {
    if (pageNumber === "...") return;
    setCurrentPage(pageNumber);
  };

  // Handle fast backward (skip to first page)
  const fastBackward = () => {
    setCurrentPage(1);
  };

  // Handle fast forward (skip to last page)
  const fastForward = () => {
    const lastPage = Math.ceil(Timelinedata.length / TimelinedataPerPage);
    setCurrentPage(lastPage);
  };


  const handletimelineSearch = (timeline) => {
    localStorage.removeItem("filter_timeline_report");
    localStorage.setItem("filter_timeline_report", timeline.timelineSearchKeywordPageNo)
    window.open("/timeline", "_blank");

  };

  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{
        width: "700px",
        maxHeight: "80vh",
        overflow: "hidden",
      }}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center border-bottom py-2 px-3">
          <h5 className="m-0">Timeline data ({allTimelinedatacount})</h5>
          <button onClick={closeTimelinedataModal} className="btn border-0 fs-5">
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Table */}
        <div
          style={{
            // minHeight: "200px",
            maxHeight: "calc(-310px + 100vh)",
            overflowY: "auto",
          }}
        >
          {Timelinedata.length === 0 ? (
            <p className="text-muted">No Timelinedata found.</p>
          ) : (
            <Table1 hover>
              <thead className="custom-header-border">
                <tr>
                  <th className="center-text">S. No.</th>
                  <th className="center-text">Keyword</th>
                  <th className="center-text">Created Date</th>
                  <th className="center-text">Actions</th>
                </tr>
              </thead>
              <tbody>
                {displayedTimelinedata.map((timeline, index) => (
                  <tr key={timeline.timelineSearchId} className="custom-row-border">
                    <td className="center-text">
                      {(currentPage - 1) * TimelinedataPerPage + (index + 1)}
                    </td>
                    <td className="center-text">{timeline.timelineSearchKeyword}</td>
                    <td className="center-text">{timeline.timelineSearchCreatedOn}</td>
                    <td className="center-text">
                      <Button1 variant="outline-primary" size="sm" onClick={() => handletimelineSearch(timeline)}>
                        <i className="fas fa-eye"></i>
                      </Button1>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table1>
          )}
        </div>

        {/* Pagination */}
        <Pagination className="custom-pagination justify-content-end mt-1">
          <Pagination.First onClick={fastBackward} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
          {pageNumbers.map((number, idx) => (
            <Pagination.Item
              key={idx}
              active={number === currentPage}
              onClick={() => paginate(number)}
            >
              {number}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers[pageNumbers.length - 1]} />
          <Pagination.Last onClick={fastForward} disabled={currentPage === pageNumbers[pageNumbers.length - 1]} />
        </Pagination>
      </div>
    </div>
  );
};



const Analysis = ({ fetchAllCases, handleShowUploads, allCasesData }) => {

  // initial loading show this content end
  const [inputWidth, setInputWidth] = useState(200);

  const textSizerRef = useRef(null);
  const scrollRef = useRef(null);
  const collapseCleanup = useRef(null);
  const smartSearchRef = useRef(null);
  //console.log(allCasesData);
  const [case_data, setcase_data] = useState(localStorage.getItem("caseID"));
  // console.log("case_data123", case_data);
  const [selectedCase, setselectedCase] = useState(null);
  const [AIreportHtml, setAIreportHtml] = useState(null);
  const [issearchenabled, setissearchenabled] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [showTags, setShowTags] = useState(false);
  const [showTimelineModal, setShowTimelinemodal] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [firstAIagent, setfirstAIagent] = useState(null);
  //prompt start
  const [promptData, setPromptData] = useState([]);
  const [promptFilteredData, setPromptFilteredData] = useState([]);
  function getCategoryRecord(data, categoryToFind = '') {
    const trimmedCategory = categoryToFind.trim().toLowerCase();
    if (!trimmedCategory) return data;

    const result = data.filter(item => item.category.trim().toLowerCase() === trimmedCategory);
    return result.length ? result : data;
  }



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchresult, setsearchresult] = useState({});
  const [searchvaluestring, setsearchvaluestring] = useState("");

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const serachenabled = (data) => {
    setissearchenabled(true);
    setsearchresult(data);
  };
  const searchdisable = () => {
    setsearchvaluestring("")
    if (issearchenabled) {
      setissearchenabled(false);
      setsearchresult({});
      if (showPdf) {
        toggleSidebar2();
      }
    }
  };
  const handlekeywordstring = (data) => {
    setsearchvaluestring(data)
  };

  // Example dynamic usage
  useEffect(() => {
    if (selectedCategory) {
      const record = getCategoryRecord(promptData, selectedCategory?.assistantLabel);
      setPromptFilteredData(record);
      //  console.log(record);
    }
  }, [selectedCategory, promptData]);



  //prompt end

  useEffect(() => {
    if (!case_data || !allCasesData?.length) return;
    const selectedCase = allCasesData.find(
      (item) => item.caseId.toString() === case_data.toString()
    );
    setselectedCase(selectedCase);
    console.log("selectedCase", selectedCase)
    GetAISummary();
    fetchPrompt();
    fetchChatHistory();

    if (selectedCase) {
      if (!isEditing) {
        setCaseName(selectedCase?.caseName);
      }


    } else {
      console.log("Status not 100% or case not found.");
    }
  }, [case_data, allCasesData]);

  // useEffect(() => {
  //   if (!selectedCase) return;
  //   GetAISummary();
  //   fetchPrompt();
  // }, [selectedCase]);


  const [isVisible, setIsVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [caseName, setCaseName] = useState("");
  const [error, setError] = useState("");

  const [pdfLoading, setPdfLoading] = useState(false);
  const [docLoading, setDocLoading] = useState(false);





  // Dynamically measure text width
  useEffect(() => {
    if (textSizerRef.current) {
      const width = textSizerRef.current.offsetWidth;
      setInputWidth(width + 20); // +20 for padding
    }
  }, [caseName]);
  const statusIcons = {
    1: faUpload,
    2: faBell,
    3: faScissors,
    4: faRobot,
    5: faFile,
    6: faFileLines,
    7: faListUl
  };

  // Runs when data or ID changes

  const [isAccordionOpen, setIsAccordionOpen] = useState(false);


  useEffect(() => {
    const updateCaseID = () => {
      // console.log("updateCaseID called");
      const currentID = localStorage.getItem("caseID");
      localStorage.removeItem("filter_timeline_report");
      // console.log("caseIDUpdated triggered, new caseID:", currentID);
      // setAImedicalindexreport(false);
      // setAImedchronreport(false);
      // setSubmittalsreport(false);
      // setTagAddinResult(false);
      // setcase_data(currentID);
      // setIsVisible(false);
      // setSelectedCategory(null);
      // setAIreportHtml(null);
      setcase_data(prevCaseData => {
        if (currentID !== prevCaseData) {
          setAIsummaryInprogress(false);
          setAImedicalindexreport(false);
          setisMindmapreport(false);
          setAIMissingorduplicatereport(false);
          setAImedchronreport(false);
          setSubmittalsreport(false);
          setTagAddinResult(false);
          setIsVisible(false);
          setSelectedCategory(null);
          setAIreportHtml(null);
        }

        return currentID; // update state
      });
      if (scrollRef.current) scrollRef.current.scrollTop = 0;

      const tryFindAccordion = (attempt = 1) => {
        const collapseEl = document.getElementById('collapseOne');

        if (collapseEl) {
          const bsCollapse = window.bootstrap.Collapse.getOrCreateInstance(collapseEl, {
            toggle: false
          });

          const isCurrentlyShown = collapseEl.classList.contains('show');

          if (!isCurrentlyShown) {
            bsCollapse.show();
            setIsAccordionOpen(true); // ✅ update state
            // console.log("Accordion triggered open");

            const toggleButton = collapseEl.previousElementSibling?.querySelector('.accordion-button');
            if (toggleButton) {
              toggleButton.classList.remove('collapsed');
              toggleButton.setAttribute('aria-expanded', 'true');
            }
          } else {
            console.log("Accordion already open");
          }

          if (scrollRef.current) scrollRef.current.scrollTop = 0;

          const handleShown = () => {
            // console.log('Accordion shown event');
            setIsAccordionOpen(true); // ✅ keep in sync
          };

          collapseEl.addEventListener('shown.bs.collapse', handleShown);

          collapseCleanup.current = () => {
            collapseEl.removeEventListener('shown.bs.collapse', handleShown);
          };

          // } else if (attempt <= 50) {
        } else if (attempt > 0) {
          // console.log(`collapseEl not found on attempt ${attempt}, retrying...`);
          setTimeout(() => tryFindAccordion(attempt + 1), 700);
        } else {
          // console.log("collapseEl not found after max retries");
        }
      };


      tryFindAccordion();
    };

    window.addEventListener("caseIDUpdated", updateCaseID);
    const timeout = setTimeout(() => updateCaseID(), 0);

    return () => {
      window.removeEventListener("caseIDUpdated", updateCaseID);
      clearTimeout(timeout);
      if (collapseCleanup.current) collapseCleanup.current();
    };
  }, []);


  const handleOpenAccordion = () => {
    const collapseEl = document.getElementById('collapseOne');

    if (collapseEl) {
      const bsCollapse = window.bootstrap.Collapse.getOrCreateInstance(collapseEl, {
        toggle: false
      });

      const isCurrentlyShown = collapseEl.classList.contains('show');

      if (!isCurrentlyShown) {
        bsCollapse.show();

        const toggleButton = collapseEl.previousElementSibling?.querySelector('.accordion-button');
        if (toggleButton) {
          toggleButton.classList.remove('collapsed');
          toggleButton.setAttribute('aria-expanded', 'true');
        }
      }

      // Scroll to top of scroll container if available
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      console.warn("Accordion element not found");
    }
  };



  // useEffect(() => {
  //   const updateCaseID = () => {
  //     console.log("updateCaseID called");
  //     const currentID = localStorage.getItem("caseID");
  //     console.log("caseIDUpdated triggered, new caseID:", currentID);
  //     setcase_data(currentID);

  //     if (scrollRef.current) scrollRef.current.scrollTop = 0;

  //     setIsVisible(false);
  //     const tryFindAccordion = (attempt = 1) => {

  //       const collapseEl = document.getElementById('collapseOne');
  //       if (collapseEl) {
  //         console.log("collapseEl found on attempt", attempt);
  //         console.log("collapseEl classes:", collapseEl.classList.value);

  //         const bsCollapse = window.bootstrap.Collapse.getOrCreateInstance(collapseEl);
  //         console.log(collapseEl.classList)
  //         if (!collapseEl.classList.contains('show')) {
  //           bsCollapse.show();
  //           console.log('triggered opened')

  //           const toggleButton = collapseEl.previousElementSibling?.querySelector('.accordion-button');
  //           if (toggleButton) {
  //             toggleButton.classList.remove('collapsed');
  //             toggleButton.setAttribute('aria-expanded', 'true');
  //             if (scrollRef.current) {
  //               scrollRef.current.scrollTop = 0;
  //             }
  //           }
  //         } else {
  //            //bsCollapse.show();
  //           if (scrollRef.current) {
  //             scrollRef.current.scrollTop = 0;
  //           }
  //           console.log("Accordion is already open; skipping show().");
  //         }

  //         const handleShown = () => console.log('Accordion opened');
  //         collapseEl.addEventListener('shown.bs.collapse', handleShown);

  //         collapseCleanup.current = () => {
  //           collapseEl.removeEventListener('shown.bs.collapse', handleShown);
  //         };

  //       } else if (attempt <= 20) {
  //         console.log(`collapseEl not found on attempt ${attempt}, retrying...`);
  //         setTimeout(() => tryFindAccordion(attempt + 1), 500); // try every 100ms, up to 10 tries
  //       } else {
  //         console.log("collapseEl not found after max retries");
  //       }
  //     };
  //     setSelectedCategory(null);
  //     setAIreportHtml(null);
  //     tryFindAccordion(); // start polling
  //   };

  //   window.addEventListener("caseIDUpdated", updateCaseID);

  //   // Delay manual call until after the DOM is fully rendered
  //   const timeout = setTimeout(() => updateCaseID(), 0);

  //   return () => {
  //     window.removeEventListener("caseIDUpdated", updateCaseID);
  //     clearTimeout(timeout);
  //     if (collapseCleanup.current) collapseCleanup.current();
  //   };
  // }, []);



  const [showPdf, setShowPdf] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const [caseAnalysis, setCaseAnalysis] = useState({});
  const summaryRef = useRef(null);

  const bottomRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const chatboxRef = useRef(null);
  const inputRef = useRef(null);
  const scrollContainerRef = useRef(null);


  const [AISelectedApp, setAISelectedApp] = useState(null);
  const [AIsummaryInprogress, setAIsummaryInprogress] = useState(false);
  const [AImedicalindexreport, setAImedicalindexreport] = useState(false);
  const [AImedchronreport, setAImedchronreport] = useState(false);
  const [AIMissingorduplicate, setAIMissingorduplicatereport] = useState(false);
  const [Submittalsreport, setSubmittalsreport] = useState(false);
  const [TagaddInResult, setTagAddinResult] = useState(false);
  const [isMindmapreport, setisMindmapreport] = useState(false);


  const handleTagAddEnable = () => {
    setTagAddinResult(true);
  };
  const handleTagAddDisable = () => {
    setTagAddinResult(false);
  };

  const handleAppContent = (item) => {
    if (TagaddInResult) {
      toast.warning("Please save or close the current tag before opening another option.", {
        autoClose: 3000,
      });
      return;
    }
    if (item?.summaryPmtAgentData === "Timeline.jsx") {
      localStorage.removeItem("filter_timeline_report");
      window.open("/timeline", "_blank");
    } else {
      handleremovesearchcaseclick();
      setissearchenabled(false);
      setAImedchronreport(false);
      setAImedicalindexreport(false);
      setAIsummaryInprogress(false);
      setAIMissingorduplicatereport(false);
      setAIsummaryInprogress(false);
      setSubmittalsreport(false);
      setisMindmapreport(false);
      setAISelectedApp(item);
      if (item?.summaryProcessStatus === 0 || item?.summaryProcessStatus === 2 || item.appDataProcessStatus === 0 || item.appDataProcessStatus === 2) {
        setAIsummaryInprogress(true);
      } else {
        if (item?.appFrontEndReference === "Mindmap.jsx") {
          setisMindmapreport(true);
        } else if (item?.summaryPmtAgentData === "Medicalindex.jsx") {
          setAImedicalindexreport(true);
        } else if (item?.summaryPmtAgentData === "Medchronreport.jsx") {
          setAImedchronreport(true);
        } else if (item?.summaryPmtAgentData === "Submittalsreport.jsx") {
          setSubmittalsreport(true);
        } else if (item?.summaryPmtAgentData === "MissingorDuplicate.jsx") {
          setAIMissingorduplicatereport(true);
        } else {
          const rawHtml = item?.agentData || `<p>${item?.summaryPmtLabel} is not available.</p>`;
          const sanitizedHtml = DOMPurify.sanitize(rawHtml);
          setAIreportHtml(sanitizedHtml);
        }
      }
    }
  };

  //right bar functionality start
  // const [isPromptOpen, setIsPromptOpen] = useState(false);

  // const toggleRightBarPrompt = () => setIsPromptOpen(!isPromptOpen);
  const [openAccordionItem, setOpenAccordionItem] = useState('0');

  const toggleAccordion = (id) => {
    setOpenAccordionItem(openAccordionItem === id ? '' : id);
  };
  //right bar functionality end 

  //chat input functionality start
  const handleContainerClick = (e) => {
    // // Optional: prevent focusing if clicked directly on input or buttons
    // if (e.target === inputRef.current) return;

    // inputRef.current?.focus();
  };



  const handleToggle = () => {
    setIsVisible((prev) => !prev);
  };





  const defaultHeight = "24px";
  const maxHeight = 200; // px
  useEffect(() => {
    const textarea = inputRef.current;
    if (!textarea) return;

    const adjustHeight = () => {
      //textarea.style.height = "auto";
      textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`;
    };

    const handleKeyDown = (e) => {
      adjustHeight();

      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault(); // prevent newline
        handleSend();
        textarea.blur(); // remove focus to collapse textarea
      }
    };

    const handleBlur = () => {
      textarea.style.height = defaultHeight;
    };

    textarea.addEventListener("keydown", handleKeyDown);
    textarea.addEventListener("blur", handleBlur);

    // Initialize to default height on mount
    textarea.style.height = defaultHeight;

    return () => {
      textarea.removeEventListener("keydown", handleKeyDown);
      textarea.removeEventListener("blur", handleBlur);
    };
  }, [input]); // re-register listeners if input changes




  const handleSend = async (questionPrompt = null) => {
    setIsVisible(true);
    setIsPopupVisible(false);
    let question = questionPrompt || input;
    inputRef.current.style.height = defaultHeight; // reset height

    if (typeof question === "object" && question !== null) {
      question = question.text || "";
    }
    // Convert to string and trim
    question = String(question).trim();
    if (!question) return;
    const currentTime = moment.utc().add(3, 'minutes').add(31, 'seconds').format('YYYY-MM-DD HH:mm:ss');
    const userMessage = { sender: "user", text: question, created_on: currentTime };
    setMessages((prev) => [...prev, userMessage]);

    setInput("");
    setIsTyping(true); // show typing indicator
    // setIsPromptOpen(false);


    try {
      const response = await axios.post(`${API_BASE_URL}ask_chatbot`, {
        case_id: case_data ? case_data : null,
        question: question,
        fk_agent_assistant_id: selectedCategory?.agentAssistantId || null
      });

      const aiAnswer = response.data.answer || "Sorry, no answer received.";
      const replayTime = response.data.created_on || moment.utc().add(3, 'minutes').add(31, 'seconds').format('YYYY-MM-DD HH:mm:ss');
      const aiMessage = {
        sender: "ai",
        text: `AttestaAI : ${aiAnswer} `,
        created_on: replayTime,
        animate: true,
      };

      setMessages((prev) => [...prev, aiMessage]);
    } catch (error) {
      console.error("Error fetching AI response:", error);

      const errorMessage = {
        sender: "ai",
        text: "Something went wrong. Please try again.",
        animate: false,
      };

      setMessages((prev) => [...prev, errorMessage]);
    } finally {
      setIsTyping(false);
    }
  };

  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") handleSend();
  // };
  //chat input functionality end
  //pdf download start
  function randomPrefix() {
    return Math.floor(100 + Math.random() * 900); // 3-digit number between 100 and 999
  }
  // Helper: Convert an image URL (from import) to base64
  const imageUrlToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Allow loading from different origin
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = this.naturalWidth;
        canvas.height = this.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(this, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = () => reject(new Error("Failed to load image"));
      img.src = url;
    });
  };
  const downloadPDF = async () => {
    if (!summaryRef.current) return;
    setPdfLoading(true);
    // Clone DOM node
    const summaryClone = summaryRef.current.cloneNode(true);

    // Prevent mid-item page breaks
    // Adjust font sizes
    summaryClone.querySelectorAll("h1").forEach(el => el.style.fontSize = "17px");
    summaryClone.querySelectorAll("h2, h3").forEach(el => el.style.fontSize = "17px");
    summaryClone.querySelectorAll("th, td").forEach(el => {
      el.style.fontSize = "14px";
      el.style.border = "0.5px solid #ccc"; // light gray thin border
      el.style.borderCollapse = "collapse";
      el.style.padding = "4px"; // optional: for spacing
    });
    // Prevent mid-item page breaks
    // summaryClone.querySelectorAll("p,h1, h2, h3, h4, h5, li, table, thead, tr").forEach((el) => {
    //   el.style.pageBreakInside = "avoid";
    //   el.style.breakInside = "avoid";
    // });
    summaryClone.querySelectorAll("p, h1, h2, h3, h4, h5, li, table, thead, tr").forEach((el) => {
      el.style.pageBreakInside = "avoid";
      el.style.breakInside = "avoid";

      if (el.tagName === "THEAD") {
        el.style.display = "table-header-group"; // force thead repeat on new pages
      }

      if (el.tagName === "TFOOT") {
        el.style.display = "table-footer-group";
      }

      if (el.tagName === "TR") {
        el.style.pageBreakAfter = "auto";
      }
    });


    // Create a wrapper
    const wrapper = document.createElement("div");
    wrapper.appendChild(summaryClone);

    const options = {
      margin: 0.5,
      filename: `${caseAnalysis?.case_name}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };


    try {
      const id = localStorage.getItem("caseID");
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");

      await document.fonts.ready;

      // Create html2pdf instance from DOM
      const worker = html2pdf().set(options).from(wrapper);

      // Generate the PDF and get jsPDF instance
      const pdf = await worker.toPdf().get("pdf");

      // Convert imported logo (from import logo from './logo.png') to base64
      const logoBase64 = await imageUrlToBase64(Logo);

      // Add watermark and logo to each page

      const totalPages = pdf.internal.getNumberOfPages();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);

        // Semi-transparent
        pdf.setGState(new pdf.GState({ opacity: 0.2 }));

        // Add rotated text watermark centered on the page
        pdf.setFontSize(48);
        pdf.setTextColor(150, 150, 150);
        pdf.text(
          "AttestaAI",                          // text
          pageWidth / 2,                       // center x
          pageHeight / 2,                      // center y
          {
            align: "center",
            angle: 45,                         // rotation angle in degrees
          }
        );

        // Reset opacity
        pdf.setGState(new pdf.GState({ opacity: 1 }));

        // Optional: Add opaque logo at top-right corner on every page
        // const logoWidth = 0.5;   // half the width
        // const logoHeight = 0.25; // half the height
        // pdf.addImage(
        //   logoBase64,
        //   "PNG",
        //   pageWidth - logoWidth - 0.5,
        //   0.6,
        //   logoWidth,
        //   logoHeight
        // );
        const logoWidth = 0.4;
        const logoHeight = 0.2;
        const logoX = pageWidth - logoWidth - 0.5;
        const logoY = 0.2; // Adjusted to avoid table content

        pdf.addImage(
          logoBase64,
          "PNG",
          logoX,
          logoY,
          logoWidth,
          logoHeight
        );


      }




      // const totalPages = pdf.internal.getNumberOfPages();
      // for (let i = 1; i <= totalPages; i++) {
      //   pdf.setPage(i);

      //   // Watermark text
      //   pdf.setFontSize(40);
      //   pdf.setTextColor(150, 150, 150);
      //   pdf.text(
      //     "AttestaAI",
      //     pdf.internal.pageSize.getWidth() / 2,
      //     pdf.internal.pageSize.getHeight() / 2,
      //     {
      //       align: "center",
      //       angle: 45,
      //     }
      //   );

      //   // Logo image at top-right corner
      //   const logoWidth = 1; // inches
      //   const logoHeight = 0.5;
      //   pdf.addImage(
      //     logoBase64,
      //     "PNG",
      //     pdf.internal.pageSize.getWidth() - logoWidth - 0.5,
      //     0.5,
      //     logoWidth,
      //     logoHeight
      //   );
      // }

      const pdfBlob = pdf.output("blob");

      // Create ZIP
      const zip = new JSZip();
      zip.file(
        `${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.pdf`,
        pdfBlob
      );

      // Generate and trigger ZIP download
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const fileName = `${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.zip`;
      saveAs(zipBlob, fileName);
      setPdfLoading(false);

    } catch (err) {
      setPdfLoading(false);
      console.error("Failed to generate ZIP:", err);
    }
  };
  //pdf download end
  //word download start
  const downloadWord = async () => {
    try {
      if (!summaryRef.current) return;
      setDocLoading(true);
      const paragraphs = [];

      const rgbToHex = (r, g, b) =>
        "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");

      const getFontSizeForTag = (tag) => {
        switch (tag.toLowerCase()) {
          case "h1": return 32;
          case "h2": return 28;
          case "h3": return 26;
          case "h4": return 24;
          case "h5": return 22;
          case "h6": return 20;
          default: return 20;
        }
      };

      const processNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (!text) return null;
          return new Paragraph(text);
        }

        if (node.nodeType !== Node.ELEMENT_NODE) return null;

        const tag = node.nodeName.toLowerCase();
        const styles = window.getComputedStyle(node);
        const text = node.textContent.trim();
        if (!text) return null;

        const color = styles.color.replace("rgb", "").replace(/[()]/g, "").split(",");
        let [r, g, b] = color.map(Number);
        let hexColor = rgbToHex(r, g, b);
        if ((r === 255 && g === 255 && b === 255) || styles.opacity === "0") {
          hexColor = "#000000";
        }

        const isBold =
          styles.fontWeight === "bold" ||
          styles.fontWeight === "bolder" ||
          parseInt(styles.fontWeight) >= 600 ||
          /^h[1-6]$/.test(tag) ||
          tag === "strong" || tag === "b";

        const isItalic = styles.fontStyle === "italic";
        const fontSize = getFontSizeForTag(tag);
        const fontFamily = styles.fontFamily.split(",")[0].replace(/['"]/g, "");

        const run = new TextRun({
          text,
          bold: isBold,
          italics: isItalic,
          color: hexColor,
          size: fontSize,
          font: fontFamily,
        });

        if (tag === "ul") {
          const listItems = Array.from(node.querySelectorAll("li")).map(li =>
            new Paragraph({
              text: li.textContent.trim(),
              bullet: { level: 0 },
              spacing: { after: 100 },
            })
          );
          return listItems;
        }

        if (tag === "table") {
          const rows = Array.from(node.querySelectorAll("tr")).map(tr => {
            const cells = Array.from(tr.children).map(cell => {
              const isHeader = cell.nodeName.toLowerCase() === "th";
              const cellText = cell.textContent.trim() || "";

              const paragraph = new Paragraph({
                children: [
                  new TextRun({
                    text: cellText,
                    bold: isHeader,
                  }),
                ],
              });

              return new TableCell({
                children: [paragraph],
                margins: { top: 100, bottom: 100, left: 100, right: 100 }
              });
            });

            return new TableRow({ children: cells });
          });

          return new Table({
            rows,
            width: {
              size: 100,
              type: "pct",
            },
          });
        }

        return new Paragraph({
          children: [run],
          spacing: { after: 100 },
        });
      };

      const extractParagraphs = (element) => {
        element.childNodes.forEach((node) => {
          const result = processNode(node);
          if (Array.isArray(result)) {
            paragraphs.push(...result);
          } else if (result) {
            paragraphs.push(result);
          }
        });
      };

      // 1. Extract content
      extractParagraphs(summaryRef.current);

      // Watermark
      const watermarkText = new Paragraph({
        children: [
          new TextRun({
            text: "AttestaAI",
            color: "D9D9D9",
            bold: true,
            size: 40,
          }),
        ],
        alignment: "right",
      });

      // 2. Create Document
      const doc = new Document({
        sections: [
          {
            properties: {},
            headers: {
              default: new Header({
                children: [watermarkText],
              }),
            },
            children: paragraphs,
          },
        ],
      });

      // 5. Export and save the document
      //const blob = await Packer.toBlob(doc);
      //saveAs(blob, `${caseAnalysis?.case_name || "Case_Analysis"}.docx`);
      const id = localStorage.getItem("caseID");
      const now = new Date();
      // Pad with leading zeros if needed
      const pad = (n) => String(n).padStart(2, '0');

      const wordBlob = await Packer.toBlob(doc);

      const zip = new JSZip();
      zip.file(`${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.docx`, wordBlob);

      // Generate ZIP and trigger download
      const zipBlob = await zip.generateAsync({ type: "blob" });


      const fileName = `${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.zip`;
      saveAs(zipBlob, fileName);
      setDocLoading(false);

    } catch (error) {
      setDocLoading(false);
      console.error("Failed to generate Word document:", error);
    }
  };
  //word download end

  //preview right bar functionality start
  //pdf preview
  const toggleSidebar2 = () => {
    // setShowPdf((prev) => !prev); // toggles true/false

    if (showPdf) {
      setSearchItempage(null);
      setfromsearch(false);
      setfrommissing(false);
      setmissingItempage(null);
    }
    setShowPdf((prev) => {
      const newVal = !prev;
      if (newVal) {
        localStorage.setItem("closeside", "1");
      } else {
        localStorage.setItem("closeside", "2");
      }
      return newVal;
    });
  };
  const toggleSidebarclose = () => {
    if (showPdf) {
      setSearchItempage(null);
      setfromsearch(false);
      setShowPdf(false);
      localStorage.setItem("closeside", "2");
    }

  };

  //search view functionality start
  const [searchitempage, setSearchItempage] = useState(null);
  const [fromsearch, setfromsearch] = useState(false);

  const handlesearchdataclick = (item) => {

    setSearchItempage(item);
    setfromsearch(true)
    if (!showPdf) {
      toggleSidebar2();
    }
  };
  const handleremovesearchclick = () => {

    setsearchvaluestring("");
    setissearchenabled(false);
    if (smartSearchRef.current) {
      smartSearchRef.current.resetFilters();
    }
    if (showPdf) {
      toggleSidebar2();
    }

    // if (firstAIagent.summaryPmtAgentData === "Medicalindex.jsx") {
    //   setAISelectedApp(firstAIagent);
    //   setAImedicalindexreport(true);
    // } else if (firstAIagent.summaryPmtAgentData === "Medchronreport.jsx") {
    //   setAISelectedApp(firstAIagent);
    //   setAImedchronreport(true);
    // } else {
    //   setAImedicalindexreport(false);
    //   setAImedchronreport(false);
    //   const rawHtmlData = firstAIagent?.agentData || null;
    //   if (rawHtmlData) {
    //     const rawHtmlData = firstAIagent?.agentData || `<p>${firstAIagent.summaryPmtLabel} is not available.</p>`;;
    //     const sanitizedHtmlData = DOMPurify.sanitize(rawHtmlData);
    //     setAIreportHtml(sanitizedHtmlData);
    //     setAISelectedApp(firstAIagent);
    //     handleOpenAccordion();
    //   }
    // }



  };
  const handleremovesearchcaseclick = () => {
    setsearchvaluestring("");
    setissearchenabled(false);
    if (smartSearchRef.current) {
      smartSearchRef.current.resetFilters();
    }
    if (showPdf) {
      toggleSidebarclose();
    }
  };

  const [casetags, setCasetags] = useState([]);
  const [timelinedatalist, settimelinedatalist] = useState([]);
  const [casenotes, setCasenotes] = useState([]);


  const handleTagslist = async () => {
    // setShowTags(true)

    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.post(`${API_BASE_URL}tag`, {
        case_id: caseID,
        mode: "listAllTag",
        get_type: "all_active_tags"
      });

      if (response.data.status === 1) {
        const responsedata = response.data?.message?.all_pages_active_tags || [];
        if (Array.isArray(responsedata) && responsedata.length > 0) {
          setCasetags(response.data?.message);
          setShowTags(true)
        } else {
          setCasetags([]);
          toast.warning("No tags found");
        }
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  const handleTimelinereportlist = async () => {
    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.get(`${API_BASE_URL}timeline_search_repo?cId=${caseID}`);

      if (response.data.status === 1) {
        const responsedata = response.data?.data || [];
        if (Array.isArray(responsedata) && responsedata.length > 0) {
          settimelinedatalist(responsedata);
          setShowTimelinemodal(true)
        } else {
          settimelinedatalist([]);
          toast.warning("No timeline report found");
        }
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  const handlenoteslist = async () => {
    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.post(`${API_BASE_URL}note`, {
        case_id: caseID,
        "get_type": "all_notes",
        "mode": "listAllNote"
      });

      if (response.data.status === 1) {
        const responsedata = response.data?.message?.all_active_notes_list;
        if (Array.isArray(responsedata) && responsedata.length > 0) {
          setCasenotes(response.data?.message);
          setShowNotes(true)
        } else {
          setCasenotes([]);
          toast.warning("No Notes Found");
        }
      }
    } catch (error) {
      console.error("Error fetching case notes:", error);
    }
  };
  //search view functionality end
  //preview right bar functionality end


  //Case Rename functionality start
  const handleKeyDownAndBlur = (e) => {
    // Only run logic on Enter key or blur event
    if (e.type === "keydown" && e.key !== "Enter") return;

    if (caseName.trim() === "") {
      setError("Case name cannot be empty.");
    } else {
      setError("");
      setIsEditing(false);
      onRename(caseName);
    }
  };

  const onRename = async (casename) => {
    if (!casename.trim()) return;

    try {
      const response = await axios.post(`${API_BASE_URL}case_manage`, {
        case_id: case_data ? case_data : null,
        new_case_name: casename || null
      });
      if (response.data && response.data.status && response.data.status == 1) {
        setError("");
        setIsEditing(false);
        fetchAllCases();
        // GetAISummary();
      } else {
        toast.error("Case name could not be updated");
      }

    } catch (error) {
      console.error("Error fetching AI response:", error);

    }
  };
  //Case Rename functionality end



  const [isOpen, setIsOpen] = useState(false)

  const handleDropDownOpen = () => {
    setIsOpen()
  }

  //feach case view data function start

  const GetAISummary = async () => {
    // const storedId = localStorage.getItem("case_id");
    const storedId = localStorage.getItem("caseID") || null;
    if (!storedId) {
      toast.error("No case ID found.");
      return;
    }


    // if (!selectedCase?.caseServiceId) {
    //   return;
    // }

    try {
      const response = await axios.post(`${API_BASE_URL}case_view`, {
        case_id: storedId,
        // service_id: selectedCase?.caseServiceId,
      });

      if (!selectedCategory) {
        setSelectedCategory(response?.data?.message?.[0]?.case_assistant_agents?.[0] || null);
      }

      const rawHtml = response.data?.message?.[0]?.summary || "<p>AttestaAI Summary is not available.</p>";
      const sanitizedHtml = DOMPurify.sanitize(rawHtml);

      if (!AIreportHtml && !AImedicalindexreport && !AImedchronreport && !AIMissingorduplicate && !isMindmapreport) {
        handleremovesearchcaseclick();
        setAIsummaryInprogress(false);
        setAImedicalindexreport(false);
        setisMindmapreport(false);
        setAIMissingorduplicatereport(false);
        setAImedchronreport(false);
        setSubmittalsreport(false);
        setTagAddinResult(false);
        const rawAgents = response?.data?.message?.[0]?.case_summary_agents || [];
        // let first_ai_data = response?.data?.message?.[0]?.case_summary_agents?.[0] || null;

        const agents = response?.data?.message?.[0]?.case_summary_agents || [];

        let first_ai_data = null;

        if (agents.length > 0) {
          if (agents[0]?.agentSummaryId === 18 && agents.length > 1) {
            first_ai_data = agents[1];
          } else {
            first_ai_data = agents[0];
          }
        }



        if (!first_ai_data) {
          first_ai_data = response?.data?.message?.[0]?.case_apps?.[0] || null;
        }

        setfirstAIagent(first_ai_data);
        if (first_ai_data.summaryProcessStatus === 0 || first_ai_data.summaryProcessStatus === 2 || first_ai_data.appDataProcessStatus === 0 || first_ai_data.appDataProcessStatus === 2) {
          setAISelectedApp(first_ai_data);
          setAIsummaryInprogress(true);
        } else {
          if (first_ai_data?.appFrontEndReference === "Mindmap.jsx") {
            setAISelectedApp(first_ai_data);
            setisMindmapreport(true);
          } else if (first_ai_data.summaryPmtAgentData === "Medicalindex.jsx") {
            setAISelectedApp(first_ai_data);
            setAImedicalindexreport(true);
          } else if (first_ai_data.summaryPmtAgentData === "Medchronreport.jsx") {
            setAISelectedApp(first_ai_data);
            setAImedchronreport(true);
          } else if (first_ai_data.summaryPmtAgentData === "Submittalsreport.jsx") {
            setAISelectedApp(first_ai_data);
            setSubmittalsreport(true);
          } else if (first_ai_data.summaryPmtAgentData === "MissingorDuplicate.jsx") {
            setAISelectedApp(first_ai_data);
            setAIMissingorduplicatereport(true);
          } else {
            const rawHtmlData = first_ai_data?.agentData || null;
            if (rawHtmlData || response?.data?.message?.[0]?.processing_status[0] === '100%') {
              const rawHtmlData = first_ai_data?.agentData || `<p>${first_ai_data.summaryPmtLabel} is not available.</p>`;;
              const sanitizedHtmlData = DOMPurify.sanitize(rawHtmlData);
              setAIreportHtml(sanitizedHtmlData);
              setAISelectedApp(first_ai_data);
              handleOpenAccordion();
            }
          }
        }

      }
      console.log(response.data?.message[0])
      setCaseAnalysis(response.data?.message[0] || null);

      if (!isEditing) {
        setCaseName(response.data?.message[0]?.case_name);
      }

    } catch (error) {
      console.error("Error Getting AI Summary:", error);
      // toast.error("Failed to get AI summary");
    }
  };
  //feach case view data function end
  //feach chat history data function start
  const fetchChatHistory = async () => {

    try {
      const response = await axios.post(`${API_BASE_URL}chat_history`, {
        case_id: localStorage.getItem("caseID") || null, // use storedId instead of hardcoded 4
      });

      const chatHistory = response.data || null;
      if (chatHistory && chatHistory.length > 0) {
        // Map chat history to messages
        const newMessages = chatHistory.flatMap(({ question, answer, created_on }) => [
          { sender: "user", text: question, created_on: created_on },
          { sender: "ai", text: answer, created_on: created_on, animate: false },
        ]);

        setMessages(newMessages);
        // Just run the timeout to scroll once
        setTimeout(() => scrollToBottom("smooth"), 400);
      } else {
        setMessages([]);
      }
      //setMessages((prevMessages) => [...prevMessages, ...newMessages]);
    } catch (error) {
      console.error("Error fetching chat history:", error);
      //toast.error("Error fetching chat history. Please try again.");
      const errorMsg = {
        sender: "ai",
        text: "Oops! Something went wrong. Please try again.",
        animate: false,
      };
      setMessages((prevMessages) => [...prevMessages, errorMsg]);
    } finally {

    }
  };
  //feach chat history data function end

  const fetchPrompt = async () => {

    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.get(`${API_BASE_URL}prompts?case_id=${caseID}`);

      const promptList = response.data?.data || [];

      setPromptData(promptList);

    } catch (error) {
      console.error("Error fetching prompt:", error);
    } finally {

    }
  };
  useEffect(() => {
    if (!caseAnalysis || !AISelectedApp) return;
    if (selectedCase?.caseStatus[0] != '100%') return;
    const storedId = localStorage.getItem("caseID") || null;
    if (!storedId) return;

    // Only poll if selected agent is in progress (0 or 2)
    // const shouldPoll = AISelectedApp.summaryProcessStatus === 0 || AISelectedApp.summaryProcessStatus === 2;
    // console.log("heelo", shouldPoll)
    const allAgents = caseAnalysis?.case_summary_agents || [];
    const allApps = caseAnalysis?.case_apps || [];
    // console.log(allAgents)
    // const hasInProgressAgents = allAgents.some(
    //   (agent) => agent.summaryProcessStatus === 0 || agent.summaryProcessStatus === 2
    // );
    const hasInProgressAgents = [
      ...allAgents,
      ...allApps
    ].some(item => item.summaryProcessStatus === 0 || item.summaryProcessStatus === 2 || item.appDataProcessStatus === 0 || item.appDataProcessStatus === 2);

    // If no in-progress agents exist, stop here
    if (!hasInProgressAgents) return;

    const intervalId = setInterval(async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}case_view`, {
          case_id: storedId,
        });

        const updatedAgents = response?.data?.message?.[0]?.case_summary_agents || [];
        console.log(updatedAgents);
        console.log(AISelectedApp);

        // const matchingAgent = updatedAgents.find(agent => agent.agentSummaryId === AISelectedApp.agentSummaryId);
        let matchingAgent = updatedAgents.find(agent => agent.agentSummaryId === AISelectedApp.agentSummaryId);

        if (!matchingAgent) {
          const matchingApp = response?.data?.message?.[0]?.case_apps || [];
          matchingAgent = matchingApp.find(app => app.commonAppId === AISelectedApp.commonAppId);
        }

        if ((AISelectedApp.summaryProcessStatus === 0 || AISelectedApp.summaryProcessStatus === 2 || AISelectedApp.appDataProcessStatus === 0 || AISelectedApp.appDataProcessStatus == 2) && (matchingAgent?.summaryProcessStatus === 1 || matchingAgent.appDataProcessStatus === 1)) {
          clearInterval(intervalId);
          setAIsummaryInprogress(false);

          if (matchingAgent?.appFrontEndReference === "Mindmap.jsx") {
            setisMindmapreport(true);
            setAISelectedApp(matchingAgent)
          } else if (matchingAgent.summaryPmtAgentData === "Medicalindex.jsx") {
            setAImedicalindexreport(true);
          } else if (matchingAgent.summaryPmtAgentData === "Medchronreport.jsx") {
            setAImedchronreport(true);
          } else if (matchingAgent.summaryPmtAgentData === "Submittalsreport.jsx") {
            setSubmittalsreport(true);
          } else if (matchingAgent.summaryPmtAgentData === "MissingorDuplicate.jsx") {
            setAIMissingorduplicatereport(true);
          } else {
            const rawHtml = matchingAgent?.agentData || `<p>${matchingAgent.summaryPmtLabel} is not available.</p>`;
            const sanitizedHtml = DOMPurify.sanitize(rawHtml);
            setAIreportHtml(sanitizedHtml);
            handleOpenAccordion();
          }
        }
        setCaseAnalysis(response.data?.message[0] || null);

      } catch (err) {
        console.error("Polling error:", err);
      }
    }, 5000);

    return () => clearInterval(intervalId); // Cleanup on unmount or deps change

  }, [caseAnalysis, AISelectedApp]);



  // trigger GetAISummary and  fetchChatHistory start
  // useEffect(() => {

  //   if (case_data) {
  //     GetAISummary();
  //     fetchChatHistory();
  //     fetchPrompt();
  //   }

  // }, [case_data]);
  // trigger GetAISummary and  fetchChatHistory end

  //completed conctpt useCallback start brcause control re-render
  const onComplete = useCallback((idx) => {
    setMessages(prev =>
      prev.map((m, i) => (i === idx ? { ...m, animate: false } : m))
    );
  }, [setMessages]);  // setMessages is stable but good practice
  //completed conctpt useCallback end 

  //histry load automatically scorll to button  start
  const [isUserAtBottom, setIsUserAtBottom] = useState(true);
  const scrollToBottom = (behavior = "smooth") => {
    bottomRef.current?.scrollIntoView({ behavior });
  };

  // Monitor user scroll to detect if they're at the bottom
  const handleScroll = () => {
    const el = chatboxRef.current;
    if (!el) return;
    const threshold = 50; // px from bottom
    const isAtBottom =
      el.scrollHeight - el.scrollTop - el.clientHeight <= threshold;
    setIsUserAtBottom(isAtBottom);
  };

  useEffect(() => {
    const el = chatboxRef.current;
    if (!el) return;
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [chatboxRef]);

  // Auto-scroll while typing or animating
  useEffect(() => {
    const hasAnimatingAI = messages.some(
      (msg) => msg.sender === "ai" && msg.animate
    );
    if ((isTyping || hasAnimatingAI) && isUserAtBottom) {
      const interval = setInterval(() => scrollToBottom("smooth"), 300);
      return () => clearInterval(interval);
    }
  }, [messages, isTyping, isUserAtBottom]);

  // Ensure final scroll to bottom after animation/typing ends
  useEffect(() => {
    const hasAnimatingAI = messages.some(
      (msg) => msg.sender === "ai" && msg.animate
    );
    if (!isTyping && !hasAnimatingAI && isUserAtBottom) {
      setTimeout(() => scrollToBottom("smooth"), 100);
    }
  }, [isTyping, messages, isUserAtBottom]);


  //histry load automatically scorll to button end

  // case upload show status  functinality start
  const currentStatus = parseInt(selectedCase?.caseStatus[2] || 0);

  const initialMessages = [
    { message: "Your file has been successfully uploaded.", status: 1, animate: false },
    { message: "Your file has been received. You will be notified once processing is complete.", status: 2, animate: false },
    { message: "Your document is being segmented into individual page-level sections.", status: 3, animate: false },
    { message: "AttestaAI is analyzing the extracted data from your file.", status: 4, animate: false },
    { message: "AttestaAI summary of your document is being generated.", status: 5, animate: false },
    { message: "AttestaAI-generated structured prompt is being created for further analysis.", status: 6, animate: false },
    { message: 'AttestaAI global summary report has been successfully generated and finalized.', status: 7, animate: false }
  ];

  const [ducumentStatus, setDucumentStatus] = useState(initialMessages);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);

  const visibleMessages = ducumentStatus.filter(
    (msg) => parseInt(msg.status) <= currentStatus
  );

  useEffect(() => {
    if (visibleMessages[currentIndex]) {
      setDucumentStatus((prev) => {
        const updated = [...prev];
        const idx = ducumentStatus.findIndex(
          (m) => m.status === visibleMessages[currentIndex].status
        );
        if (idx !== -1) updated[idx].animate = true;
        return updated;
      });
    }
  }, [currentIndex, currentStatus]);

  const handleAnimationFinished = () => {
    const nextIndex = currentIndex + 1;
    const idx = ducumentStatus.findIndex(
      (m) => m.status === visibleMessages[currentIndex].status
    );

    setDucumentStatus((prev) => {
      const updated = [...prev];
      if (idx !== -1) updated[idx].animate = false;
      return updated;
    });

    setCurrentIndex(nextIndex);
  };

  useEffect(() => {
    if (currentStatus === 6) {
      setVisible(true);

      const timer = setTimeout(() => {
        setVisible(false);
      }, 1500); // Show for 3 seconds

      return () => clearTimeout(timer);
    }
  }, [currentStatus, case_data]);

  // case upload show status  functinality end

  //Prompt functionality start

  const wrapperRef = useRef(null);

  const handlePromptToggle = () => {
    setIsPopupVisible((prev) => !prev);
  };


  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setIsPopupVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  function shouldDisableButton(messages, isTyping, isUserAtBottom) {
    const hasAnimatingAI = messages.some(
      (msg) => msg.sender === "ai" && msg.animate
    );

    return (isTyping || hasAnimatingAI) && isUserAtBottom;
  }
  //Prompt functionality end


  //agent Dropdown functionality start

  const [isAgentOpen, setIsAgentOpen] = useState(false);
  const agentWrapperRef = useRef(null);

  const toggleAgentDropdown = (e) => {
    e.stopPropagation();
    setIsAgentOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (agentWrapperRef.current && !agentWrapperRef.current.contains(event.target)) {
        setIsAgentOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);
  //agent Dropdown functionality end

  //missingagent preview functionality start
  const [missingitempage, setmissingItempage] = useState(null);
  const [frommissing, setfrommissing] = useState(false);

  const handlemissingdataclick = (item) => {

    setmissingItempage(item);
    setfrommissing(true)
    if (!showPdf) {
      toggleSidebar2();
    }
  };
  // initial loading show this content start
  if (!caseAnalysis || Object.keys(caseAnalysis).length === 0) {
    return (
      <div className="home-one-wrapper-inner" style={{ marginTop: "100px" }}>
        <div className="home-bot-chat temp-width" style={{ maxWidth: "80%" }}>
          <div className="custome-doc-viewer-wrapper content-box-before">
            <div className="custom-doc-viewer2 uploadLoader">
              <div
                className="text-start d-flex flex-column gap-2"
                style={{ width: "200px", height: "72px" }}
              >
                <div className="d-flex flex-column">
                  <h5 className="mb-0 skeleton-line w-100">
                    Loading Document...
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  const scrollAgents = (direction) => {
    const container = document.querySelector('.agents-scroll-container');
    if (container) {
      container.scrollBy({ top: direction === 'up' ? -100 : 100, behavior: 'smooth' });
    }
  };

  const scrollApps = (direction) => {
    const container = document.querySelector('.apps-scroll-container');
    if (container) {
      container.scrollBy({ top: direction === 'up' ? -100 : 100, behavior: 'smooth' });
    }
  };



  return (
    <div id="div2" className={`right-ctn flexible row  `}>
      {/* Main content area or ceter container start */}
      <div
        style={{
          width: (showPdf) ? "55%" : "100%",
          transition: "width 0.5s ease",
        }}
      >
        <SmartSearchModal ref={smartSearchRef} isOpen={isModalOpen} closeModal={closeModal} searchenable={serachenabled} handlekeywordstring={handlekeywordstring} searchdisable={searchdisable} />
        <NotesModal
          showNotes={showNotes}
          closeNotesModal={() => setShowNotes(false)}
          allnotes={casenotes}
          searchenable={serachenabled}
          searchdisable={searchdisable}
        />
        <TagsModal
          showTags={showTags}
          closeTagsModal={() => setShowTags(false)}
          alltags={casetags}
          searchenable={serachenabled}
          searchdisable={searchdisable}
        />
        <TimelinereportModal
          showTimelineModal={showTimelineModal}
          closeTimelinedataModal={() => setShowTimelinemodal(false)}
          alltimelinedata={timelinedatalist}
        />
        <div className="toggle-btn2 d-flex justify-content-between gap-1">
          <div className={`d-flex justify-content-start gap-2`}>
            <Tooltip id="case-name" className="tooltip-custom" place="right" />
            <div
              className="d-flex justify-content-center align-content-center align-item-center rounded me-2"
              style={{ position: "relative", alignItems: 'center' }}
            >
              {/* Hidden text measurer span */}
              <span
                ref={textSizerRef}
                style={{
                  position: 'absolute',
                  visibility: 'hidden',
                  whiteSpace: 'nowrap',
                  fontSize: '1rem',
                  fontFamily: 'inherit',
                  padding: '0.375rem 0.75rem',
                  fontWeight: 400,
                  overflow: "hidden",

                }}
              >
                {caseName || 'Untitled Case (rename)'}
              </span>

              <div>
                {isEditing ? (
                  <>
                    <input
                      type="text"
                      className={`form-control h-100 ${error ? "is-invalid" : ""}`}
                      value={caseName}
                      autoFocus
                      onChange={(e) => setCaseName(e.target.value)}
                      onKeyDown={handleKeyDownAndBlur}
                      onBlur={handleKeyDownAndBlur}
                      style={{
                        // width: `${inputWidth}px`,
                        maxWidth: "300px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        padding: '0.375rem 0.75rem',
                      }}
                    />
                    {error && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
                        {error}
                      </div>
                    )}
                  </>
                ) : (
                  <h5
                    className="mb-0 p-2 h-100"
                    style={{
                      width: "fit-content",
                      //  minWidth: "200px",
                      maxWidth: "300px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      cursor: "pointer"

                    }}
                    onClick={() => setIsEditing(true)}
                  >
                    {caseName || "Untitled Case (rename)"}
                  </h5>
                )}
              </div>

              {/* Edit button (optional) */}
              {!isEditing && (
                <button
                  className="btn p-2"
                  onClick={() => setIsEditing(true)}
                  title="Edit name"
                >
                  <i className="fa fa-pencil-alt"></i>
                </button>
              )}
            </div>


            {selectedCase?.caseStatus[0] === '100%' && (<>

              {/* <!-- custome-doc-viewer-wrapper --> */}
              <div className="custome-doc-viewer-wrapper content-box-before" style={{ display: "contents" }}>
                {/* <!-- loading doc-viewer (not 100%) --> */}

                {/* <!-- end loading doc-viewer (not 100%) --><!-- doc opener --> */}
                <div className="custom-doc-viewer" style={{ display: "flex" }}>
                  <div className="d-flex gap-1 align-items-center">
                    <div className="">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                        width="28" height="28" x="0" y="0"
                        viewBox="0 0 512 512" style={{ enableBackground: 'new 0 0 512 512' }}
                        className=""><g><path d="M494.479 138.557 364.04 3.018A9.853 9.853 0 0 0 356.945 0h-194.41c-21.757 0-39.458 17.694-39.458 39.442v137.789H44.29c-16.278 0-29.521 13.239-29.521 29.513v147.744C14.769 370.761 28.012 384 44.29 384h78.787v88.627c0 21.71 17.701 39.373 39.458 39.373h295.238c21.757 0 39.458-17.653 39.458-39.351V145.385a9.85 9.85 0 0 0-2.752-6.828zM359.385 26.581l107.079 111.265H359.385V26.581zM44.29 364.308c-5.42 0-9.828-4.405-9.828-9.82V206.744c0-5.415 4.409-9.821 9.828-9.821h265.882c5.42 0 9.828 4.406 9.828 9.821v147.744c0 5.415-4.409 9.82-9.828 9.82H44.29zm433.248 108.341c0 10.84-8.867 19.659-19.766 19.659H162.535c-10.899 0-19.766-8.828-19.766-19.68V384h167.403c16.278 0 29.521-13.239 29.521-29.512V206.744c0-16.274-13.243-29.513-29.521-29.513H142.769V39.442c0-10.891 8.867-19.75 19.766-19.75h177.157v128c0 5.438 4.409 9.846 9.846 9.846h128v315.111z" fill="#000000" opacity="1" data-original="#000000"></path><path d="M132.481 249.894c-3.269-4.25-7.327-7.01-12.173-8.279-3.154-.846-9.923-1.269-20.308-1.269H72.596v84.577h17.077v-31.904h11.135c7.731 0 13.635-.404 17.712-1.212 3-.654 5.952-1.99 8.856-4.01 2.904-2.019 5.298-4.798 7.183-8.336 1.885-3.538 2.827-7.904 2.827-13.096-.001-6.731-1.636-12.221-4.905-16.471zm-14.625 23.279c-1.288 1.885-3.067 3.269-5.337 4.154s-6.769 1.327-13.5 1.327h-9.346v-24h8.25c6.154 0 10.25.192 12.288.577 2.769.5 5.058 1.75 6.865 3.75 1.808 2 2.712 4.539 2.712 7.615.001 2.5-.644 4.692-1.932 6.577zM219.481 263.452c-1.846-5.404-4.539-9.971-8.077-13.702s-7.789-6.327-12.75-7.789c-3.692-1.077-9.058-1.615-16.096-1.615h-31.212v84.577h32.135c6.308 0 11.346-.596 15.115-1.789 5.039-1.615 9.039-3.865 12-6.75 3.923-3.808 6.942-8.788 9.058-14.942 1.731-5.039 2.596-11.039 2.596-18 0-7.923-.923-14.586-2.769-19.99zm-16.616 34.731c-1.154 3.789-2.644 6.51-4.471 8.163-1.827 1.654-4.125 2.827-6.894 3.519-2.115.539-5.558.808-10.327.808h-12.75v-56.019h7.673c6.961 0 11.635.269 14.019.808 3.192.692 5.827 2.019 7.904 3.981 2.077 1.962 3.692 4.692 4.846 8.192s1.731 8.519 1.731 15.058c0 6.538-.577 11.701-1.731 15.49zM294.827 254.654v-14.308h-57.981v84.577h17.077v-35.942h35.308v-14.308h-35.308v-20.019z"
                          fill="#000000" opacity="1" data-original="#000000"></path></g>
                      </svg>
                    </div>
                    <Tooltip id="case-filename" className="tooltip-custom" place="right" strategy="fixed" offset={10} />
                    <div className="text-start d-flex flex-column gap-1 me-3">
                      <div className="d-flex flex-column">
                        <h5 className="mb-0" data-tooltip-id="case-filename"
                          data-tooltip-content={`${selectedCase?.pdf_filename} (${selectedCase?.caseServiceData?.[0]?.serviceName || "Paralegal"})`} style={{
                            maxWidth: "155px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}>{selectedCase?.pdf_filename} <span style={{ fontSize: "9px" }}>({selectedCase?.caseServiceData?.[0]?.serviceName || "Paralegal"})</span></h5>
                      </div>
                      <div className="upload-persent d-flex align-items-center gap-1">
                        <p className="mb-0">Status:</p>
                        {(() => {
                          const percentStr = selectedCase?.caseStatus?.[0] || "0%";
                          const percent = parseInt(percentStr.replace('%', '')) || 0;

                          let bgcolor = "#f7374f"; // red
                          if (percent > 80) bgcolor = "#42b966"; // green
                          else if (percent > 50) bgcolor = "#feba17"; // yellow

                          return (
                            <>
                              <div className="progress" style={{ width: "80px" }}>
                                <div
                                  className="progress-bar progress-bar-striped"
                                  role="progressbar"
                                  style={{
                                    width: selectedCase?.caseStatus?.[0] || "0%",
                                    background: bgcolor
                                  }}
                                  aria-valuenow={parseInt(
                                    selectedCase?.caseStatus?.[0]?.replace('%', '')
                                  ) || 0}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                              <span style={{ color: bgcolor }}>{selectedCase?.caseStatus[0] || '0%'}</span>
                            </>
                          );
                        })()}
                      </div>
                    </div>

                  </div>

                  {/* <!-- PDF Image with Typewriter Effect --> */}
                  <Tooltip id="case-status" className="tooltip-custom" place="right" strategy="fixed" offset={10} />
                  <div className="flex items-end" data-tooltip-id="case-status"
                    data-tooltip-content="View Document Preview">
                    <button className="doc-page-btn" id="rightCntOpener" onClick={toggleSidebar2}>View Document</button>
                  </div>
                  {/* <!-- End PDF Image --> */}

                </div>
                {/* <!-- end opener --> */}
              </div>
              {/* <!-- end custome-doc-viewer-wrapper --> */}

            </>)}
          </div>



          {selectedCase?.caseStatus[0] === '100%' && (<>
            <div className='d-flex align-items-center'>
              {/* {selectedCase?.caseServiceId === 1 && ( */}
              <>
                {showPdf ? (
                  <Dropdown>
                    <Dropdown.Toggle variant="light" className="icon-button">
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => { openModal(); }}>
                        <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => { handlenoteslist(); }}>
                        <i className="fa-solid fa-note-sticky me-2"></i> Notes
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => { handleTagslist(); }}>
                        <i className="fa-solid fa-tags me-2"></i> Tags
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => { handleTimelinereportlist(); }}>
                        <i className="fa-solid fa-flag me-2"></i> Timeline Report
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                ) : (
                  // Show search bar when PDF is not shown
                  <>
                    <div className="d-flex align-items-center ">
                      <div className="search-bar-container">
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search"
                          value={searchvaluestring || ""}
                          onClick={openModal}
                        />
                      </div>


                      <div className="d-flex align-items-center gap-1">
                        <Tooltip id="notes-button" className="tooltip-custom" />
                        <div className="icon-button"
                          onClick={() => handlenoteslist()}
                          style={{ cursor: "pointer" }}
                          data-tooltip-id="notes-button"
                          data-tooltip-content='Notes'
                        >
                          <i className="fa-solid fa-note-sticky"></i>

                        </div>
                        <Tooltip id="tags-button" className="tooltip-custom" />
                        <div className="icon-button"
                          onClick={() => handleTagslist()}
                          style={{ cursor: "pointer" }}
                          data-tooltip-id="tags-button"
                          data-tooltip-content='Tags'
                        >
                          <i className="fa-solid fa-tags"></i>
                        </div>
                        <Tooltip id="timelinereport-button" className="tooltip-custom" />
                        <div className="icon-button"
                          onClick={() => handleTimelinereportlist()}
                          style={{ cursor: "pointer" }}
                          data-tooltip-id="timelinereport-button"
                          data-tooltip-content='Timeline Report'
                        >
                          <i className="fa-solid fa-flag"></i>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
              {/* )
              } */}

              {/* {!showPdf && ( */}
              <Tooltip id="preview-popup" className="tooltip-custom" />
              <button
                id="toggleBtn2"
                data-tooltip-id="preview-popup"
                data-tooltip-content={showPdf ? 'close preview PDF' : 'Open preview PDF'}
                className="btn data-btn"
                onClick={toggleSidebar2}
              >
                <span style={{ display: showPdf ? 'none' : 'block' }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="shrink-0 me-1"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5 10C5 9.85913 5.05943 9.72479 5.16366 9.63003L10.6637 4.63003C10.868 4.44428 11.1842 4.45933 11.37 4.66366C11.5557 4.86799 11.5407 5.18422 11.3363 5.36997L6.7933 9.5L17.5 9.5C17.7761 9.5 18 9.72386 18 10C18 10.2761 17.7761 10.5 17.5 10.5L6.7933 10.5L11.3363 14.63C11.5407 14.8158 11.5557 15.132 11.37 15.3363C11.1842 15.5407 10.868 15.5557 10.6637 15.37L5.16366 10.37C5.05943 10.2752 5 10.1409 5 10Z"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.5 2C2.77614 2 3 2.22386 3 2.5L3 17.5C3 17.7761 2.77614 18 2.5 18C2.22385 18 2 17.7761 2 17.5L2 2.5C2 2.22386 2.22386 2 2.5 2Z"
                    />
                  </svg>
                </span>
                {/* <span><i className="fa-solid fa-file-pdf"></i> </span> */}
                <span style={{ display: !showPdf ? 'none' : 'block' }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    id="open-svg"
                    // style={{ display: "none" }}
                    className="shrink-0 opacity-100 scale-100 group-hover:scale-100 group-hover:opacity-0 transition-all text-text-300 ms-1"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.5 2C17.7761 2 18 2.22386 18 2.5V17.5C18 17.7761 17.7761 18 17.5 18C17.2239 18 17 17.7761 17 17.5V2.5C17 2.22386 17.2239 2 17.5 2ZM8.63003 4.66366C8.81578 4.45933 9.13201 4.44428 9.33634 4.63003L14.8363 9.63003C14.9406 9.72479 15 9.85913 15 10C15 10.1409 14.9406 10.2752 14.8363 10.37L9.33634 15.37C9.13201 15.5557 8.81578 15.5407 8.63003 15.3363C8.44428 15.132 8.45934 14.8158 8.66366 14.63L13.2067 10.5H2.5C2.22386 10.5 2 10.2761 2 10C2 9.72386 2.22386 9.5 2.5 9.5H13.2067L8.66366 5.36997C8.45934 5.18422 8.44428 4.86799 8.63003 4.66366Z"
                    />
                  </svg>
                </span>

              </button>
              {/* )} */}
            </div>
          </>)}

        </div>

        <div className="page-wrapper">
          {/* <!-- Page Content--> */}
          <div className={`document-report page-content d-flex flex-column w-100 align-items-center justify-content-between ${(isMindmapreport) ? 'mindmap-div' : ''}`}>
            <div className={`home-one-wrapper-main position-relative  ${(AImedicalindexreport || AImedchronreport || Submittalsreport || issearchenabled || AIMissingorduplicate || AIsummaryInprogress || isMindmapreport) ? 'disable-scroll-style' : ''}`}>
              <div className="home-one-wrapper" style={{ maxWidth: '100%' }}>
                {/* <!-- page content --> */}

                <div className="home-one-wrapper-inner" >
                  <div className={`home-bot-chat ${!issearchenabled ? 'temp-width' : 'temp-searchwidht'} ${isMindmapreport ? 'temp-mindmap-width' : ''}`}>
                    {/* <!-- custome-doc-viewer-wrapper --> */}
                    {selectedCase?.caseStatus[0] !== '100%' && (
                      <div className="custome-doc-viewer-wrapper content-box-before mb-1">
                        <div
                          id="rightCntOpener" className="custom-doc-viewer" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="View Document Preview"

                          onClick={toggleSidebar2}
                          style={{ display: 'flex', maxWidth: '100%' }}
                        >
                          <div className="text-start d-flex flex-column gap-2">
                            <div className="d-flex flex-column">
                              <h5 className="mb-0">{selectedCase?.pdf_filename} <span style={{ fontSize: "9px" }}>({selectedCase?.caseServiceData?.[0]?.serviceName || "Paralegal"})</span></h5>
                              <span>document</span>
                            </div>
                            <div className="upload-persent d-flex align-items-center gap-1">
                              <p className="mb-0">Status:</p>
                              {(() => {
                                const percentStr = selectedCase?.caseStatus?.[0] || "0%";
                                const percent = parseInt(percentStr.replace('%', '')) || 0;

                                let bgcolor = "#f7374f"; // red
                                if (percent > 80) bgcolor = "#42b966"; // green
                                else if (percent > 50) bgcolor = "#feba17"; // yellow

                                return (
                                  <>
                                    <div className="progress" style={{ width: "80px" }}>
                                      <div
                                        className="progress-bar progress-bar-striped"
                                        role="progressbar"
                                        style={{
                                          width: selectedCase?.caseStatus?.[0] || "0%",
                                          background: bgcolor
                                        }}
                                        aria-valuenow={parseInt(
                                          selectedCase?.caseStatus?.[0]?.replace('%', '')
                                        ) || 0}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      ></div>
                                    </div>
                                    <span style={{ color: bgcolor }}>{selectedCase?.caseStatus[0] || '0%'}</span>
                                  </>
                                );
                              })()}
                            </div>
                          </div>

                          {/* <!-- PDF Image with Typewriter Effect --> */}
                          <div className="flex items-end artifact-block-cell-preview relative">
                            <div className="artifact-content typewriter-text">
                              <CleanHtml
                                summaryHtml={AIreportHtml}
                              // summaryRef={summaryRef}
                              />
                            </div>
                          </div>
                          {/* <!-- End PDF Image --> */}
                        </div>
                      </div>
                    )}
                    <div id="aiGreetingContainer" className="ai-greeting-container my-0">
                      {
                        selectedCase?.caseStatus[0] !== '100%' ?
                          <div className="border-l-2 border-blue-600 pl-6 ml-4 mb-3" style={{ fontSize: '14px' }}>
                            {visibleMessages.map((msg, i) => {
                              const isCurrent = i === currentIndex;

                              return (
                                <div key={i} className="flex items-start gap-3 py-1">
                                  {/* Dot */}
                                  <div className="w-3 h-3 rounded-full bg-blue-600 flex-shrink-0"></div>

                                  {/* Message with icon and animation */}
                                  <div className="text-base font-normal">
                                    {msg.animate && isCurrent ? (
                                      <>
                                        <span className="me-1 ms-1">
                                          <FontAwesomeIcon icon={statusIcons[msg.status]} />
                                        </span>
                                        <TypeAnimation
                                          sequence={[
                                            msg.message,
                                            100,
                                            () => {
                                              handleAnimationFinished();
                                            },
                                          ]}
                                          speed={75}
                                          wrapper="span"
                                          cursor={false}
                                          style={{ display: "inline-block" }}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        {!msg.animate && i < currentIndex ? (
                                          <>
                                            <span className="me-1 ms-1">
                                              <FontAwesomeIcon icon={statusIcons[msg.status]} />
                                            </span>
                                            <span>{msg.message}</span>
                                          </>
                                        ) : null}
                                      </>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          : <div className={`typewriter-text my-0 fs-5 fw-normal notification ms-3 ${visible ? "show" : "hide"}`}>
                            <span className="me-1 ms-1">
                              <FontAwesomeIcon icon={statusIcons[6]} />
                            </span>Your global summary report is ready and finalized.
                          </div>
                      }
                    </div>

                    {/* <!-- chat 5 --> */}
                    {selectedCase?.caseStatus[0] === '100%' && (
                      <>
                        {issearchenabled ? (
                          <SearchResultTable entries={searchresult} handlesearchdataclick={handlesearchdataclick} handleremovesearchclick={handleremovesearchclick} searchterm={searchvaluestring} tagenable={handleTagAddEnable} tagadddisable={handleTagAddDisable} />

                        )
                          : (
                            <>

                              {isMindmapreport ? (
                                <MindmapApp AISelectedApp={AISelectedApp} caseName={caseName} />
                              ) : AIsummaryInprogress ? (
                                <AisummaryagentInprogress AISelectedApp={AISelectedApp} />
                              ) : (AImedicalindexreport ? (
                                <Medicalindex AISelectedApp={AISelectedApp} />
                              ) : (AImedchronreport ? (
                                <MedChronReport AISelectedApp={AISelectedApp} />
                              ) : (Submittalsreport ? (
                                <SubmittalsReport AISelectedApp={AISelectedApp} />
                              ) : (AIMissingorduplicate ? (
                                <MissingorDuplicatereport AISelectedApp={AISelectedApp} selectedpdf={caseAnalysis?.pdf_url} handlemissingdataclick={handlemissingdataclick} />
                              ) : (
                                <>

                                  <div className="chat-5-out bot-chats ai-report gap-2 sticky-item mt-0" >
                                    <div className="accordion chat5 border-0" id="analysisAccordion">
                                      {/* <!-- Item 1 --> */}

                                      <div className="accordion-item"  >
                                        {/* <span className="vertical-line"></span> */}
                                        <h2 className="accordion-header d-flex justify-content-between align-items-center w-100">
                                          {/* Accordion toggle button */}

                                          <button
                                            className={`accordion-button ${!isAccordionOpen ? 'collapsed' : ''}`}
                                            // className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne"
                                            aria-controls="collapseOne"
                                            style={{ flex: 1, textAlign: 'left' }}

                                          >
                                            <Tooltip id="ai-summary-tooltip" className="tooltip-custom" />
                                            <div className="analysis-row" data-tooltip-id="ai-summary-tooltip"
                                              data-tooltip-content={'AttestaAI Summary'}>
                                              <div className="d-flex align-items-center">
                                                <div className="custom-icon-wrapper">
                                                  <span
                                                    className="custom-icon attesta-blue"
                                                    dangerouslySetInnerHTML={{
                                                      __html: AISelectedApp?.summaryPmtIcon || '<i class="fa-solid fa-brain custom-icon attesta-blue"></i>',
                                                    }}
                                                  ></span>
                                                </div>
                                                <span className="ms-2 attesta-blue">{AISelectedApp?.summaryPmtLabel || "AttestaAI Summary"}</span>
                                              </div>
                                              {/* <!-- skeleton animation --> */}
                                              <div className="text-muted small">
                                                View analysis
                                              </div>
                                            </div>
                                          </button>

                                          {/* Action buttons outside the toggle button */}
                                          <div className="d-flex  ms-2">
                                            <Tooltip id="pdf-download-tooltip" className="tooltip-custom" />
                                            <button
                                              type="button"
                                              className="btn common-btn p-1 border-0"
                                              onClick={(e) => {
                                                e.stopPropagation(); // optional safety
                                                setPdfLoading(true);
                                                downloadPDF();
                                              }}
                                              data-tooltip-id="pdf-download-tooltip"
                                              data-tooltip-content={`${AISelectedApp?.summaryPmtLabel || "AttestaAI Summary"} Download PDF`}
                                            >

                                              {/* <i className="fa-regular fa-file-pdf fa-lg"></i> */}
                                              {/* <i className="fa-solid fa-file-pdf fa-lg"></i> */}
                                              <img
                                                src={pdfImg}
                                                alt="PDF Icon"
                                                style={{ width: '18px', height: '22px' }}
                                              />
                                              {pdfLoading && (
                                                <Spinner
                                                  size="sm"
                                                  color="secondary"
                                                  style={{
                                                    position: 'absolute',
                                                    top: '8px',
                                                    right: '28px',
                                                    width: '2.2rem',
                                                    height: '2.2rem',
                                                  }}
                                                />
                                              )}

                                            </button>

                                            <Tooltip id="word-download-tooltip" className="tooltip-custom" />
                                            <button
                                              type="button"
                                              className="btn common-btn p-1 border-0"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setDocLoading(true);
                                                downloadWord();
                                              }}
                                              data-tooltip-id="word-download-tooltip"
                                              data-tooltip-content={`${AISelectedApp?.summaryPmtLabel || "AttestaAI Summary"} Download Word`}
                                            >

                                              {/* <i className="fa-regular fa-file-word fa-lg"></i> */}
                                              {/* <i className="fa-solid fa-file-word fa-lg"></i> */}
                                              <img
                                                src={docImg}
                                                alt="Word Icon"
                                                style={{ width: '18px', height: '22px' }}
                                              />

                                              {docLoading && (
                                                <Spinner
                                                  size="sm"
                                                  color="secondary"
                                                  style={{
                                                    position: 'absolute',
                                                    top: '8px',
                                                    right: '-2px',
                                                    width: '2.2rem',
                                                    height: '2.2rem',
                                                  }}
                                                />
                                              )}
                                            </button>
                                          </div>
                                        </h2>

                                        <div
                                          id="collapseOne"
                                          // className="accordion-collapse collapse"
                                          className={`accordion-collapse collapse ${isAccordionOpen ? 'show' : ''}`}
                                          data-bs-parent="#analysisAccordion"
                                          style={{
                                            // maxHeight: 'calc(100vh - 410px)',
                                            //maxHeight: isVisible ? '300px' : '430px', 
                                            // maxHeight: isVisible ? `calc(100vh - 640px)` : "calc(-417px + 100vh)",
                                            minHeight: "200px",
                                            maxHeight: isVisible ? `300px` : "calc(-370px + 100vh)",
                                            overflowY: "auto"
                                          }}
                                        >
                                          <div ref={scrollRef} className="accordion-body" style={{
                                            // maxHeight: 'calc(100vh - 415px)',
                                            //maxHeight: `calc(100vh - ${isVisible ? '200px' : '430px'})`,
                                            // maxHeight: isVisible ? '200px' : '430px'
                                            // maxHeight: isVisible ? `calc(100vh - 640px)` : "calc(-417px + 100vh)",
                                            minHeight: "200px",
                                            maxHeight: isVisible ? `231px` : "calc(-370px + 100vh)",
                                          }}>
                                            <CleanHtml summaryHtml={AIreportHtml} summaryRef={summaryRef} />

                                          </div>
                                        </div>
                                      </div>


                                    </div>
                                    <hr className="divider my-0" style={{ display: "none" }} />
                                    <div className="dwd-options d-flex justify-content-end w-100 mb-0"
                                      style={{
                                        visibility: isVisible ? 'visible' : 'hidden',
                                      }}
                                    >
                                      <div className="text-end">
                                        <Tooltip id="ai-chat-tooltip" className="tooltip-custom" />
                                        <button
                                          type="button"
                                          className="d-flex align-items-center btn common-btn p-1 border-0"
                                          onClick={(e) => {
                                            e.stopPropagation(); // optional safety
                                            handleToggle()
                                          }}
                                          data-tooltip-id="ai-chat-tooltip"
                                          data-tooltip-content={!isVisible ? "Open the AttestaAI Chat" : "Close the AttestaAI Chat"}
                                        >
                                          <span>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              version="1.1"
                                              xmlnsXlink="http://www.w3.org/1999/xlink"
                                              width="25"
                                              height="25"
                                              viewBox="0 0 60 60"
                                              style={{ enableBackground: "new 0 0 512 512" }}
                                            >
                                              <g>
                                                <path
                                                  d="M57 27a2.996 2.996 0 0 0-2.816 2H48v-4h6a1 1 0 1 0 0-2h-6v-4h7c1.103 0 2-.897 2-2v-2.184A2.996 2.996 0 0 0 59 12c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.402 2 2.816V17h-7v-1c0-2.206-1.794-4-4-4h-1V5h2.184A2.996 2.996 0 0 0 48 7c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.996 2.996 0 0 0-2.816 2H43c-1.103 0-2 .897-2 2v7h-4V6a1 1 0 1 0-2 0v6h-4V5.816A2.996 2.996 0 0 0 33 3c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.402 2 2.816V12h-4V6a1 1 0 1 0-2 0v6h-4V5c0-1.103-.897-2-2-2h-2.184A2.996 2.996 0 0 0 12 1c-1.654 0-3 1.346-3 3s1.346 3 3 3a2.996 2.996 0 0 0 2.816-2H17v7h-1c-2.206 0-4 1.794-4 4v1H5v-2.184A2.996 2.996 0 0 0 7 12c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.402 2 2.816V17c0 1.103.897 2 2 2h7v4H6a1 1 0 1 0 0 2h6v4H5.816A2.996 2.996 0 0 0 3 27c-1.654 0-3 1.346-3 3s1.346 3 3 3a2.996 2.996 0 0 0 2.816-2H12v4H6a1 1 0 1 0 0 2h6v4H5c-1.103 0-2 .897-2 2v2.184A2.996 2.996 0 0 0 1 48c0 1.654 1.346 3 3 3s3-1.346 3-3a2.996 2.996 0 0 0-2-2.816V43h7v1c0 2.206 1.794 4 4 4h1v7h-2.184A2.996 2.996 0 0 0 12 53c-1.654 0-3 1.346-3 3s1.346 3 3 3a2.996 2.996 0 0 0 2.816-2H17c1.103 0 2-.897 2-2v-7h4v6a1 1 0 1 0 2 0v-6h4v6.184A2.996 2.996 0 0 0 27 57c0 1.654 1.346 3 3 3s3-1.346 3-3a2.996 2.996 0 0 0-2-2.816V48h4v6a1 1 0 1 0 2 0v-6h4v7c0 1.103.897 2 2 2h2.184A2.996 2.996 0 0 0 48 59c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.996 2.996 0 0 0-2.816 2H43v-7h1c2.206 0 4-1.794 4-4v-1h7v2.184A2.996 2.996 0 0 0 53 48c0 1.654 1.346 3 3 3s3-1.346 3-3a2.996 2.996 0 0 0-2-2.816V43c0-1.103-.897-2-2-2h-7v-4h6a1 1 0 1 0 0-2h-6v-4h6.184A2.996 2.996 0 0 0 57 33c1.654 0 3-1.346 3-3s-1.346-3-3-3zm-1-16a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-8-8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM30 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-8 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM3 31a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm8 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm18 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm18-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-10-5c0 1.103-.897 2-2 2H16c-1.103 0-2-.897-2-2V16c0-1.103.897-2 2-2h28c1.103 0 2 .897 2 2zm11-13a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                                                  fill="#000000"
                                                  opacity="1"
                                                />
                                                <path
                                                  d="M25.511 22.21C25.352 21.498 24.731 21 24 21s-1.352.498-1.512 1.212l-3.465 15.571a1.001 1.001 0 0 0 .76 1.193 1.005 1.005 0 0 0 1.193-.76l1.161-5.217h3.725l1.161 5.217a1 1 0 0 0 1.954-.433zM22.583 31l1.418-6.372L25.419 31h-2.835zM38 23a1 1 0 1 0 0-2h-6a1 1 0 1 0 0 2h2v14h-2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2V23z"
                                                  fill="#000000"
                                                  opacity="1"
                                                />
                                              </g>
                                            </svg>
                                          </span>
                                          {isVisible ?
                                            <span>
                                              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="shrink-0 me-1">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5c.1409 0 .2752.0594.37.1637l5 5c.1842.2043.1692.5205-.0351.7047-.2043.1842-.5205.1692-.7047-.0351L10 6.707 5.3698 10.833c-.2043.1842-.5205.1692-.7047-.0351-.1842-.2043-.1692-.5205.0351-.7047l5-5c.0948-.1043.2291-.1637.37-.1637Z" />
                                              </svg>
                                            </span> :
                                            <span>
                                              <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="shrink-0 me-1">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 15c-.1409 0-.2752-.0594-.37-.1637l-5-5c-.1842-.2043-.1692-.5205.0351-.7047.2043-.1842.5205-.1692.7047.0351L10 13.293l4.6302-4.1263c.2043-.1842.5205-.1692.7047.0351.1842.2043.1692.5205-.0351.7047l-5 5c-.0948.1043-.2291.1637-.37.1637Z" />
                                              </svg>
                                            </span>
                                          }
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {/* { isVisible ?  */}
                                  <div className="section-scroll2"
                                    style={{
                                      visibility: isVisible ? 'visible' : 'hidden',
                                      minHeight: isVisible ? '200px' : '0',
                                      maxHeight: isVisible ? 'calc(100vh - 370px)' : '0',
                                      height: isVisible ? 'auto' : '0',
                                      overflowY: isVisible ? 'auto' : 'hidden',
                                      paddingRight: isVisible ? '20px' : '0',
                                      transition: 'max-height 0.3s ease, padding 0.3s ease',
                                      marginRight: '5px',
                                    }}
                                    ref={chatboxRef}
                                  >
                                    <div className="chat-container">
                                      <ul className="chatbox" style={{ maxWidth: '100%' }}>
                                        {messages.map((msg, index) => (
                                          <ChatMessage
                                            key={index}
                                            msg={msg}
                                            index={index}
                                            onComplete={onComplete}
                                          />
                                        ))}

                                        {(isTyping || messages.some(
                                          (msg) => msg.sender === "ai" && msg.animate === true
                                        )) && (
                                            <li className="m-0 p-0">
                                              <img
                                                loading="lazy"
                                                src={loadImg}
                                                className="typing-gif"
                                                alt="typing..."
                                                style={{ display: "flex" }}
                                              />
                                            </li>
                                          )}
                                        {/* Put scroll target here */}
                                        <li style={{ padding: 0, margin: 0 }}>
                                          <div ref={bottomRef} />
                                        </li>
                                      </ul>


                                    </div>

                                    {/* <div ref={bottomRef} /> */}
                                  </div>
                                  {/* : null}
                           */}

                                </>
                              )))))}
                            </>
                          )

                        }


                      </>
                    )}
                  </div>
                </div>

                {/* <!-- end page content --> */}
              </div>
            </div>
            {/* <!-- chat box --> */}

            {selectedCase?.caseStatus[0] === '100%' && (

              (!AImedicalindexreport && !AImedchronreport && !Submittalsreport && !issearchenabled && !AIMissingorduplicate && !AIsummaryInprogress && !isMindmapreport) && (
                <div className="document-report d-flex flex-column w-100 align-items-center">
                  <div className="btm-chatbutton-wrap d-flex justify-content-end w-100 mb-0"
                    style={{
                      visibility: !isVisible ? 'visible' : 'hidden',
                    }}
                  >
                    <div className="text-end">
                      <Tooltip id="ai-chat-tooltip" className="tooltip-custom" />
                      <button
                        type="button"
                        className="d-flex align-items-center btn common-btn p-1 border-0"
                        onClick={(e) => {
                          e.stopPropagation(); // optional safety
                          handleToggle()
                        }}
                        data-tooltip-id="ai-chat-tooltip"
                        data-tooltip-content={!isVisible ? "Open the AttestaAI Chat" : "Close the AttestaAI Chat"}
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="25"
                            height="25"
                            viewBox="0 0 60 60"
                            style={{ enableBackground: "new 0 0 512 512" }}
                          >
                            <g>
                              <path
                                d="M57 27a2.996 2.996 0 0 0-2.816 2H48v-4h6a1 1 0 1 0 0-2h-6v-4h7c1.103 0 2-.897 2-2v-2.184A2.996 2.996 0 0 0 59 12c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.402 2 2.816V17h-7v-1c0-2.206-1.794-4-4-4h-1V5h2.184A2.996 2.996 0 0 0 48 7c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.996 2.996 0 0 0-2.816 2H43c-1.103 0-2 .897-2 2v7h-4V6a1 1 0 1 0-2 0v6h-4V5.816A2.996 2.996 0 0 0 33 3c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.402 2 2.816V12h-4V6a1 1 0 1 0-2 0v6h-4V5c0-1.103-.897-2-2-2h-2.184A2.996 2.996 0 0 0 12 1c-1.654 0-3 1.346-3 3s1.346 3 3 3a2.996 2.996 0 0 0 2.816-2H17v7h-1c-2.206 0-4 1.794-4 4v1H5v-2.184A2.996 2.996 0 0 0 7 12c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.402 2 2.816V17c0 1.103.897 2 2 2h7v4H6a1 1 0 1 0 0 2h6v4H5.816A2.996 2.996 0 0 0 3 27c-1.654 0-3 1.346-3 3s1.346 3 3 3a2.996 2.996 0 0 0 2.816-2H12v4H6a1 1 0 1 0 0 2h6v4H5c-1.103 0-2 .897-2 2v2.184A2.996 2.996 0 0 0 1 48c0 1.654 1.346 3 3 3s3-1.346 3-3a2.996 2.996 0 0 0-2-2.816V43h7v1c0 2.206 1.794 4 4 4h1v7h-2.184A2.996 2.996 0 0 0 12 53c-1.654 0-3 1.346-3 3s1.346 3 3 3a2.996 2.996 0 0 0 2.816-2H17c1.103 0 2-.897 2-2v-7h4v6a1 1 0 1 0 2 0v-6h4v6.184A2.996 2.996 0 0 0 27 57c0 1.654 1.346 3 3 3s3-1.346 3-3a2.996 2.996 0 0 0-2-2.816V48h4v6a1 1 0 1 0 2 0v-6h4v7c0 1.103.897 2 2 2h2.184A2.996 2.996 0 0 0 48 59c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.996 2.996 0 0 0-2.816 2H43v-7h1c2.206 0 4-1.794 4-4v-1h7v2.184A2.996 2.996 0 0 0 53 48c0 1.654 1.346 3 3 3s3-1.346 3-3a2.996 2.996 0 0 0-2-2.816V43c0-1.103-.897-2-2-2h-7v-4h6a1 1 0 1 0 0-2h-6v-4h6.184A2.996 2.996 0 0 0 57 33c1.654 0 3-1.346 3-3s-1.346-3-3-3zm-1-16a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-8-8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM30 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-8 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM3 31a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm8 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm18 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm18-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-10-5c0 1.103-.897 2-2 2H16c-1.103 0-2-.897-2-2V16c0-1.103.897-2 2-2h28c1.103 0 2 .897 2 2zm11-13a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                                fill="#000000"
                                opacity="1"
                              />
                              <path
                                d="M25.511 22.21C25.352 21.498 24.731 21 24 21s-1.352.498-1.512 1.212l-3.465 15.571a1.001 1.001 0 0 0 .76 1.193 1.005 1.005 0 0 0 1.193-.76l1.161-5.217h3.725l1.161 5.217a1 1 0 0 0 1.954-.433zM22.583 31l1.418-6.372L25.419 31h-2.835zM38 23a1 1 0 1 0 0-2h-6a1 1 0 1 0 0 2h2v14h-2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2V23z"
                                fill="#000000"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </span>
                        {isVisible ?
                          <span>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="shrink-0 me-1">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5c.1409 0 .2752.0594.37.1637l5 5c.1842.2043.1692.5205-.0351.7047-.2043.1842-.5205.1692-.7047-.0351L10 6.707 5.3698 10.833c-.2043.1842-.5205.1692-.7047-.0351-.1842-.2043-.1692-.5205.0351-.7047l5-5c.0948-.1043.2291-.1637.37-.1637Z" />
                            </svg>
                          </span> :
                          <span>
                            <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="shrink-0 me-1">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 15c-.1409 0-.2752-.0594-.37-.1637l-5-5c-.1842-.2043-.1692-.5205.0351-.7047.2043-.1842.5205-.1692.7047.0351L10 13.293l4.6302-4.1263c.2043-.1842.5205-.1692.7047.0351.1842.2043.1692.5205-.0351.7047l-5 5c-.0948.1043-.2291.1637-.37.1637Z" />
                            </svg>
                          </span>
                        }
                      </button>
                    </div>
                  </div>
                  <div
                    className="btm-chat-wrap text-center mt-0"
                    onClick={handleContainerClick}
                  >


                    {/* <!-- enlargeing part --> */}

                    {/* <!-- end enlargeing part --> */}
                    <div className="chat-bot-wrapper w-100">
                      <div className="chat-bot-inner">
                        <div className="chat-ctn">
                          <div className="chat-ctn-inner" id="chatBox">
                            <textarea
                              id="userInput"
                              value={input}
                              onChange={(e) => setInput(e.target.value)}
                              // onKeyDown={handleKeyDown}
                              ref={inputRef}
                              className="bot-chat-type"
                              placeholder={`Ask AttestaAI to get the information from Global Summary of ${selectedCase?.caseName}`}
                              style={{ height: defaultHeight }}
                            />
                            {/* <textarea id="userInput" className="bot-chat-type" placeholder="What’s next?" style="height: 24px;"></textarea>
                        <input
                          type="text"
                          id="userInput"
                          value={input}
                          onChange={(e) => setInput(e.target.value)}
                          onKeyDown={handleKeyDown}
                          ref={inputRef}
                          className="bot-chat-type"
                          placeholder={`Ask Attesta to get the information from Global Summary of ${selectedCase?.caseName}`}
                        /> */}
                            <div className="center-msg" id="centerMsg">
                              <h5 className="mb-0"></h5>
                            </div>
                          </div>
                        </div>

                        <div className="chat-sender mt-1">
                          <div className="chat-footer d-flex gap-1 justify-content-between">
                            <div className="left-tools d-flex align-items-end">
                              <Tooltip id="file-new-file-tooltip" className="tooltip-custom" />
                              <div className="file-upload-area dropdown me-1" data-tooltip-id="file-new-file-tooltip"
                                data-tooltip-content={`New ${localStorage.getItem('userdocumentlabel') || 'Project'}`}>
                                <label
                                  className="upload-icon btn"
                                  id="fileDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"

                                >
                                  <i className="fa-solid fa-plus"></i>
                                </label>

                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="fileDropdown"
                                >
                                  <li>
                                    <a
                                      onClick={() => { handleShowUploads() }}
                                      className="dropdown-item d-flex align-items-center gap-2"
                                    >
                                      <i className="fa-solid fa-paperclip"></i> New{' '}{localStorage.getItem('userdocumentlabel') || 'Project'}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <div className="d-flex gap-1 align-items-end ql-menu-wrapper" ref={wrapperRef}>

                                {Array.isArray(promptFilteredData) && promptFilteredData.length > 0 ? (
                                  <>
                                    {/* SHOW FIRST 4 PROMPTS */}
                                    {/* <div className="d-flex gap-2 align-items-start"> */}
                                    {promptFilteredData
                                      .flatMap((category) => category.questions)
                                      .slice(0, 4)
                                      .map((q) => (
                                        <button key={q.pk_prompt_id} className="ql-btn" onClick={() => handleSend(q.prompt)} disabled={shouldDisableButton(messages, isTyping, isUserAtBottom)}>
                                          {q.prompt}
                                        </button>
                                      ))}

                                    {/* SHOW ICON ONLY IF THERE ARE MORE THAN 4 PROMPTS */}
                                    {promptFilteredData.flatMap((category) => category.questions).length > 4 && (
                                      <><Tooltip id="quick-link-tooltip" className="tooltip-custom" />
                                        <i
                                          className={`fa-solid fa-angle-up text-disapper ql-menu-toggle ${isPopupVisible ? 'rotate' : ''}`}
                                          onClick={handlePromptToggle}
                                          style={{ cursor: 'pointer' }}
                                          data-tooltip-id="quick-link-tooltip"
                                          data-tooltip-content={`More Prompts`}
                                        ></i></>
                                    )}
                                    {/* </div> */}

                                    {/* POPUP WITH FULL PROMPTS CATEGORIZED */}
                                    <div className={`ql-popup ${isPopupVisible ? 'show' : ''}`}>
                                      <div className="ql-popup-inner align-items-start">
                                        {promptFilteredData.map((category) => (
                                          <div key={category.pk_category_id} className="d-flex flex-column align-items-start">
                                            <h5 className="mb-2">{category.category}:</h5>
                                            <div className="d-flex flex-wrap align-items-start" style={{ gap: "6px" }}>
                                              {category.questions.map((q) => (
                                                <button key={q.pk_prompt_id} className="ql-btn" onClick={() => handleSend(q.prompt)} disabled={shouldDisableButton(messages, isTyping, isUserAtBottom)}>
                                                  {q.prompt}
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  // OPTIONAL: show fallback if promptData is null/empty
                                  null
                                )}
                              </div>
                            </div>

                            <div className="d-flex right-tools gap-2 align-items-end">

                              <div className="agents-wrapper position-relative agent-custom-height" ref={agentWrapperRef}>

                                {caseAnalysis?.case_assistant_agents && Object.keys(caseAnalysis?.case_assistant_agents).length > 0 ? (
                                  <>
                                    <Tooltip id="input-agent-tooltip" className="tooltip-custom" />
                                    <button className="agents-toggle d-flex align-items-center gap-2" onClick={toggleAgentDropdown} data-tooltip-id="input-agent-tooltip"
                                      data-tooltip-content={`Analyst`}>
                                      <a className="dropdown-item d-flex align-items-center gap-2">
                                        <img src={selectedCategory?.assistantImg || agent1} alt="again" className="dropdown-img" />
                                        <div className="d-flex flex-column text-left align-items-start agents-info">
                                          <h4 className="mb-0">{selectedCategory?.assistantName || "Jhon"}</h4>
                                          <p className="mb-0"> {selectedCategory?.assistantLabel || "Analyst"}</p>
                                        </div>
                                      </a>
                                      {/* <a className="dropdown-item d-flex align-items-center gap-2">
                                    <img src={agent1} alt="again" className="dropdown-img"/> 
                                    <div className="d-flex flex-column text-left align-items-start agents-info">
                                      <h4 className="mb-0">{"Jhon"}</h4>
                                      <p className="mb-0"> Analyst</p>
                                    </div>
                                  </a>  */}
                                      <i className={`fa-solid fa-chevron-up arrow-icon mt-1 ${isAgentOpen ? 'rotate' : ''
                                        }`}></i>
                                    </button>

                                    {isAgentOpen && (<div className="agents-popup custom-popup show">
                                      <ul className="list-unstyled m-0">

                                        {caseAnalysis?.case_assistant_agents && caseAnalysis?.case_assistant_agents.map((item) => (

                                          <li>
                                            <a className="dropdown-item d-flex align-items-center gap-2" key={`agent-${item.agentAssistantId}`} onClick={() => { setSelectedCategory(item); setIsAgentOpen(false); }}>
                                              <img src={item.assistantImg || agent1} alt="New Upload" className="dropdown-img" />
                                              <div className="d-flex flex-column text-left align-items-start agents-info">
                                                <h4 className="mb-1">{item.assistantName || "Jhon"}</h4>
                                                <p className="mb-0"> {item.assistantLabel || "Analyst"}</p>
                                              </div>
                                            </a>
                                          </li>
                                        ))}

                                      </ul>
                                    </div>)}
                                  </>) : (null)}
                              </div>

                              <Tooltip id="input-submit-tooltip" className="tooltip-custom" />
                              <button className="send-btn" onClick={() => { handleSend(null) }} data-tooltip-id="input-submit-tooltip"
                                data-tooltip-content={`Send`}>
                                <i className="fa-solid fa-arrow-up"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="file-upload-ctn" id="uploadedFileSection">
                      <div className="uploaded-files d-flex flex-column justify-content-between align-items-start position-relative">
                        <div className="file-close-btn" id="fileCloseBtn">
                          <i className="icofont-close-line"></i>
                        </div>
                        <div id="fileNameDisplay" className="file-name"></div>
                        <div className="file-type d-flex justify-content-center align-items-center">
                          PDF
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )

            )}

            {/* <!-- end chat box --> */}
          </div>
          {/* <!-- end page content --> */}
          {/* {selectedCase?.caseStatus[0] === '100%' && caseAnalysis?.case_summary_agents && Object.keys(caseAnalysis?.case_summary_agents).length > 1 ? (

              <div className="right-sidebar d-flex flex-column align-items-center justify-content-center">
                <Tooltip id={`agent-summary-tooltip`} className="tooltip-custom" />
                {caseAnalysis?.case_summary_agents && caseAnalysis?.case_summary_agents.map((item) => (
                  <div key={item.agentSummaryId}>
                    <div className={`icon-item mb-1 ${item.agentSummaryId == AISelectedApp?.agentSummaryId ? 'active' : ''}`} title={item.summaryPmtLabel} key={`Summary` + item.agentSummaryId}
                      data-tooltip-content={item.summaryPmtLabel}
                      data-tooltip-id="agent-summary-tooltip"
                      onClick={() => { handleAppContent(item), handleOpenAccordion() }}
                    >
                      <span dangerouslySetInnerHTML={{ __html: item.summaryPmtIcon }}></span>
                    </div>
                  </div>
                ))}

                         
              </div>
             
          ) : null} */}
          {selectedCase?.caseStatus[0] === '100%' && (
            <div className="right-sidebar-container d-flex flex-column align-items-center justify-content-start">

              {/* ==== AGENTS SECTION ==== */}
              {caseAnalysis?.case_summary_agents && Object.keys(caseAnalysis?.case_summary_agents).length > 0 && (
                <div className="agents-section w-100 d-flex flex-column align-items-center">
                  <Tooltip id="agent-summary-tooltip" className="tooltip-custom" />

                  {/* Scroll Up Icon 
                  {caseAnalysis.case_summary_agents.length >= 5 && (
                    <i
                      className="fa-solid fa-angle-up scroll-icon "
                      onClick={() => scrollAgents('up')}
                    ></i>
                  )}*/}

                  {/* Agents List */}
                  <div className="agents-scroll-container">
                    {caseAnalysis.case_summary_agents.map((item) => (
                      <div key={item.agentSummaryId}>
                        <div
                          className={`icon-item ${item.agentSummaryId === AISelectedApp?.agentSummaryId ? 'active' : ''
                            }`}
                          title={item.summaryPmtLabel}
                          data-tooltip-content={item.summaryPmtLabel}
                          data-tooltip-id="agent-summary-tooltip"
                          onClick={() => {
                            handleAppContent(item);
                            handleOpenAccordion();
                          }}
                        >
                          <span dangerouslySetInnerHTML={{ __html: item.summaryPmtIcon }}></span>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Scroll Down Icon 
                  {caseAnalysis.case_summary_agents.length >= 5 && (
                    <i
                      className="fa-solid fa-angle-down scroll-icon mt-1"
                      onClick={() => scrollAgents('down')}
                    ></i>
                  )}*/}
                </div>
              )}

              {/* ==== APPS SECTION ==== */}
              {caseAnalysis?.case_apps && caseAnalysis?.case_apps.length > 0 && (
                <div className="apps-section w-100 d-flex flex-column align-items-center mt-1">
                  <Tooltip id="app-summary-tooltip" className="tooltip-custom" />

                  {/* Scroll Up Icon 
                  // {caseAnalysis.case_apps.length >= 5 && (
                    // <i
                    //   className="fa-solid fa-angle-up scroll-icon mb-1"
                    //   onClick={() => scrollApps('up')}
                    // ></i>
                  //)}*/}

                  {/* Apps List */}
                  <div className="apps-scroll-container">
                    {caseAnalysis.case_apps.map((item) => (
                      <div key={item.agentSummaryId}>
                        <div
                          className={`icon-item ${item.agentSummaryId === AISelectedApp?.agentSummaryId ? 'active' : ''
                            }`}
                          title={item.appName}
                          data-tooltip-content={item.appName}
                          data-tooltip-id="agent-summary-tooltip"
                          onClick={() => {
                            handleAppContent(item);
                            handleOpenAccordion();
                          }}
                        >
                          <span dangerouslySetInnerHTML={{ __html: item.appIcon }}></span>
                        </div>
                      </div>
                    ))}
                  </div>


                  {/* Scroll Down Icon
                  {caseAnalysis.case_apps.length >= 5 && (
                    // <i
                    //   className="fa-solid fa-angle-down scroll-icon mt-1"
                    //   onClick={() => scrollApps('down')}
                    // ></i>
                  )} */}
                </div>
              )}
            </div>
          )}





        </div>


        {/* <div className="slim-sidebar position-fixed d-flex flex-column align-items-center top-0 end-0">
          <div className="slim-menu-item">
            <i className="fa-solid fa-house"></i>
            <span className="slim-menu-label">Home</span>
          </div>
          <div className="slim-menu-item">
            <i className="fa-solid fa-user"></i>
            <span className="slim-menu-label">Profile</span>
          </div>
          <div className="slim-menu-item">
            <i className="fa-solid fa-gear"></i>
            <span className="slim-menu-label">Settings</span>
          </div>
          <div className="slim-menu-item">
            <i className="fa-solid fa-right-from-bracket"></i>
            <span className="slim-menu-label">Logout</span>
          </div>
        </div> */}


      </div>
      {/* Main content area or ceter container end */}
      {/* Right side preview content area or right container use hide and show start */}
      <div
        style={{
          width: (showPdf) ? "45%" : "100%",
          transition: "width 0.5s ease",
          background: "#F9FBFD",
        }}
      >
        {showPdf && (
          <ReportPdf
            toggleSidebar2={toggleSidebar2}
            pdf={caseAnalysis?.pdf_url}
            caseName={caseAnalysis?.case_name}
            case_id={caseAnalysis?.case_id}
            type={fromsearch || frommissing ? 1 : 2}
            searchitempage={(fromsearch && searchitempage)
              ? searchitempage
              : ((frommissing && missingitempage)
                ? missingitempage
                : "")}

          />
        )}

      </div>
      {/* Right side preview content area or right container use hide and show end */}
      {/* Right bar or Offcampus for prompt contaent start */}
      {/* <Offcanvas direction="end" className="promptRightPopup" isOpen={isPromptOpen} toggle={toggleRightBarPrompt}>
          <OffcanvasHeader toggle={toggleRightBarPrompt}>
            General Questions
          </OffcanvasHeader>
          <OffcanvasBody>
            <div className="container p-0">
              
              <Accordion open={openAccordionItem} toggle={toggleAccordion}>
                {promptData.length > 0 ? promptData.map((section, index) => (
                  <AccordionItem key={index}>
                    <AccordionHeader targetId={String(index)}>
                      {section.category}
                    </AccordionHeader>
                    <AccordionBody accordionId={String(index)}>
                      <div className={`accordion-body-wrapper ${openAccordionItem === String(index) ? 'show' : ''}`}>
                          <div>
                            {section.questions.map((q, i) => (
                              <p key={i} className="me-2 question-custom" 
                                  onClick={() => {handleSend(q.prompt)}}>
                                    {q.prompt}
                                  </p>
                            ))}
                          </div>
                          </div>
                    </AccordionBody>
                  </AccordionItem>
                )) : 'No Data'}
              </Accordion>
            </div>
          </OffcanvasBody>
        </Offcanvas> */}
      {/* Right bar or Offcampus for prompt contaent end */}
    </div >
  );
};

export default Analysis;
